// Instead of rental cost - we will map it to total insurance cost

const ICON_GROUND = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.16431 16.4548C9.14253 17.535 8.27484 18.3949 7.22142 18.3801C6.16802 18.3653 5.32364 17.4814 5.33075 16.4009C5.33786 15.3204 6.19377 14.4482 7.24727 14.448C7.76096 14.4534 8.25158 14.6678 8.61102 15.0441C8.97056 15.4205 9.16958 15.9279 9.16431 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2949 16.4548C18.2731 17.535 17.4054 18.3949 16.352 18.3801C15.2985 18.3653 14.4542 17.4814 14.4613 16.4009C14.4684 15.3204 15.3243 14.4482 16.3778 14.448C16.8915 14.4534 17.3821 14.6678 17.7416 15.0441C18.1011 15.4205 18.3001 15.9279 18.2949 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.235 17.1471C14.6173 17.1471 14.9273 16.8372 14.9273 16.4548C14.9273 16.0725 14.6173 15.7625 14.235 15.7625V17.1471ZM9.16432 15.7625C8.78198 15.7625 8.47201 16.0725 8.47201 16.4548C8.47201 16.8372 8.78198 17.1471 9.16432 17.1471V15.7625ZM13.5463 16.4548C13.5463 16.8372 13.8561 17.1471 14.2386 17.1471C14.6209 17.1471 14.9309 16.8372 14.9309 16.4548H13.5463ZM14.9309 11.593C14.9309 11.2106 14.6209 10.9007 14.2386 10.9007C13.8561 10.9007 13.5463 11.2106 13.5463 11.593H14.9309ZM14.2386 15.7625C13.8561 15.7625 13.5463 16.0725 13.5463 16.4548C13.5463 16.8372 13.8561 17.1471 14.2386 17.1471V15.7625ZM14.4644 17.1471C14.8468 17.1471 15.1567 16.8372 15.1567 16.4548C15.1567 16.0725 14.8468 15.7625 14.4644 15.7625V17.1471ZM18.2834 15.7627C17.9011 15.771 17.598 16.0875 17.6063 16.4699C17.6145 16.8521 17.9311 17.1552 18.3134 17.1469L18.2834 15.7627ZM20.3243 14.2939L21.0165 14.2817C21.0159 14.246 21.0125 14.2104 21.0064 14.1753L20.3243 14.2939ZM20.5366 11.4744C20.4711 11.0976 20.1126 10.8454 19.7359 10.9109C19.3591 10.9764 19.107 11.3349 19.1724 11.7116L20.5366 11.4744ZM14.2349 6.57882C13.8525 6.57882 13.5426 6.88878 13.5426 7.27112C13.5426 7.65347 13.8525 7.96343 14.2349 7.96343V6.57882ZM17.4488 7.27112V7.96345L17.4533 7.96341L17.4488 7.27112ZM19.4783 9.43205L18.7867 9.40254C18.7845 9.45216 18.7878 9.50186 18.7963 9.55078L19.4783 9.43205ZM19.1724 11.7116C19.2379 12.0883 19.5966 12.3406 19.9733 12.275C20.35 12.2094 20.6023 11.851 20.5366 11.4744L19.1724 11.7116ZM14.9272 7.27112C14.9272 6.88878 14.6173 6.57882 14.2349 6.57882C13.8525 6.57882 13.5426 6.88878 13.5426 7.27112H14.9272ZM13.5426 11.593C13.5426 11.9753 13.8525 12.2853 14.2349 12.2853C14.6173 12.2853 14.9272 11.9753 14.9272 11.593H13.5426ZM13.5426 7.27112C13.5426 7.65347 13.8525 7.96343 14.2349 7.96343C14.6173 7.96343 14.9272 7.65347 14.9272 7.27112H13.5426ZM14.2349 6.53266L13.5426 6.52823V6.53266H14.2349ZM13.2773 5.53851L13.2812 4.8462H13.2773V5.53851ZM4.65081 5.53851V4.84619L4.64751 4.84621L4.65081 5.53851ZM3.69232 6.53082H4.38463L4.38461 6.52766L3.69232 6.53082ZM3.69232 15.4616L4.38462 15.4647V15.4616H3.69232ZM4.65081 16.4539L4.64751 17.1462H4.65081V16.4539ZM5.32672 17.1462C5.70906 17.1462 6.01902 16.8362 6.01902 16.4539C6.01902 16.0716 5.70906 15.7616 5.32672 15.7616V17.1462ZM14.2367 10.8997C13.8544 10.8997 13.5444 11.2097 13.5444 11.592C13.5444 11.9744 13.8544 12.2844 14.2367 12.2844V10.8997ZM19.8563 12.2844C20.2387 12.2844 20.5486 11.9744 20.5486 11.592C20.5486 11.2097 20.2387 10.8997 19.8563 10.8997V12.2844Z" fill="black"/></svg>`;
const ICON_2DAY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3631 16.4548C11.3413 17.535 10.4736 18.3949 9.42018 18.3801C8.36678 18.3653 7.5224 17.4814 7.52951 16.4009C7.53662 15.3204 8.39253 14.4482 9.44603 14.448C9.95972 14.4534 10.4503 14.6678 10.8098 15.0441C11.1693 15.4205 11.3683 15.9279 11.3631 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4936 16.4548C20.4718 17.535 19.6041 18.3949 18.5507 18.3801C17.4973 18.3653 16.653 17.4814 16.6601 16.4009C16.6672 15.3204 17.523 14.4482 18.5766 14.448C19.0902 14.4534 19.5809 14.6678 19.9403 15.0441C20.2998 15.4205 20.4989 15.9279 20.4936 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.4337 17.1471C16.8161 17.1471 17.126 16.8372 17.126 16.4548C17.126 16.0725 16.8161 15.7625 16.4337 15.7625V17.1471ZM11.3631 15.7625C10.9807 15.7625 10.6708 16.0725 10.6708 16.4548C10.6708 16.8372 10.9807 17.1471 11.3631 17.1471V15.7625ZM15.745 16.4548C15.745 16.8372 16.0549 17.1471 16.4373 17.1471C16.8197 17.1471 17.1296 16.8372 17.1296 16.4548H15.745ZM17.1296 11.593C17.1296 11.2106 16.8197 10.9007 16.4373 10.9007C16.0549 10.9007 15.745 11.2106 15.745 11.593H17.1296ZM16.4373 15.7625C16.0549 15.7625 15.745 16.0725 15.745 16.4548C15.745 16.8372 16.0549 17.1471 16.4373 17.1471V15.7625ZM16.6632 17.1471C17.0455 17.1471 17.3555 16.8372 17.3555 16.4548C17.3555 16.0725 17.0455 15.7625 16.6632 15.7625V17.1471ZM20.4822 15.7627C20.0999 15.771 19.7968 16.0875 19.8051 16.4699C19.8133 16.8521 20.1299 17.1552 20.5122 17.1469L20.4822 15.7627ZM22.5231 14.2939L23.2153 14.2817C23.2146 14.246 23.2112 14.2104 23.2051 14.1753L22.5231 14.2939ZM22.7354 11.4744C22.6698 11.0976 22.3113 10.8454 21.9346 10.9109C21.5579 10.9764 21.3057 11.3349 21.3712 11.7116L22.7354 11.4744ZM16.4336 6.57882C16.0513 6.57882 15.7413 6.88878 15.7413 7.27112C15.7413 7.65347 16.0513 7.96343 16.4336 7.96343V6.57882ZM19.6476 7.27112V7.96345L19.652 7.96341L19.6476 7.27112ZM21.6771 9.43205L20.9854 9.40254C20.9833 9.45216 20.9865 9.50186 20.995 9.55078L21.6771 9.43205ZM21.3712 11.7116C21.4367 12.0883 21.7953 12.3406 22.172 12.275C22.5487 12.2094 22.801 11.851 22.7354 11.4744L21.3712 11.7116ZM17.1259 7.27112C17.1259 6.88878 16.8161 6.57882 16.4336 6.57882C16.0513 6.57882 15.7413 6.88878 15.7413 7.27112H17.1259ZM15.7413 11.593C15.7413 11.9753 16.0513 12.2853 16.4336 12.2853C16.8161 12.2853 17.1259 11.9753 17.1259 11.593H15.7413ZM15.7413 7.27112C15.7413 7.65347 16.0513 7.96343 16.4336 7.96343C16.8161 7.96343 17.1259 7.65347 17.1259 7.27112H15.7413ZM16.4336 6.53266L15.7413 6.52823V6.53266H16.4336ZM15.476 5.53851L15.48 4.8462H15.476V5.53851ZM6.84957 5.53851V4.84619L6.84627 4.84621L6.84957 5.53851ZM5.89108 6.53082H6.58339L6.58338 6.52766L5.89108 6.53082ZM5.89108 15.4616L6.58339 15.4647V15.4616H5.89108ZM6.84957 16.4539L6.84627 17.1462H6.84957V16.4539ZM7.52548 17.1462C7.90783 17.1462 8.21779 16.8362 8.21779 16.4539C8.21779 16.0716 7.90783 15.7616 7.52548 15.7616V17.1462ZM16.4355 10.8997C16.0531 10.8997 15.7432 11.2097 15.7432 11.592C15.7432 11.9744 16.0531 12.2844 16.4355 12.2844V10.8997ZM22.0551 12.2844C22.4374 12.2844 22.7474 11.9744 22.7474 11.592C22.7474 11.2097 22.4374 10.8997 22.0551 10.8997V12.2844Z" fill="black"/></svg>`;
const ICON_EXPRESS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.7355 7.22903C19.7355 7.22903 20.8527 5.51783 19.7921 4.45717C18.7314 3.39651 17.0202 4.51374 17.0202 4.51374L13.4847 8.04927L5.88562 5.63568L4 7.5213L10.1848 11.3491L8.29921 13.2347L4.82967 13.5364L4.12257 14.2435L7.77124 16.478L10.034 20.1549L10.7411 19.4478L11.0145 15.95L12.9001 14.0644L16.7279 20.2492L18.6135 18.3636L16.2 10.7646L19.7355 7.22903Z" stroke="black" stroke-width="1.2" stroke-linejoin="round"/></svg>`;
const ICON_RETURN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter"><path d="M19,8 L19,11 C19,12.1045695 18.1045695,13 17,13 L6,13"/><polyline points="8 16 5 13 8 10"/></svg>`;

const ICON_GROUND_16 = `<svg class="handling-option__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.16431 16.4548C9.14253 17.535 8.27484 18.3949 7.22142 18.3801C6.16802 18.3653 5.32364 17.4814 5.33075 16.4009C5.33786 15.3204 6.19377 14.4482 7.24727 14.448C7.76096 14.4534 8.25158 14.6678 8.61102 15.0441C8.97056 15.4205 9.16958 15.9279 9.16431 16.4548Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2949 16.4548C18.2731 17.535 17.4054 18.3949 16.352 18.3801C15.2985 18.3653 14.4542 17.4814 14.4613 16.4009C14.4684 15.3204 15.3243 14.4482 16.3778 14.448C16.8915 14.4534 17.3821 14.6678 17.7416 15.0441C18.1011 15.4205 18.3001 15.9279 18.2949 16.4548Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.235 15.7625H9.16432M14.9309 16.4548V11.593M14.2386 17.1471H14.4644M18.3134 17.1469C19.8513 17.1136 21.0435 15.8161 21.0165 14.2817M21.0064 14.1753L20.5366 11.4744M14.2349 7.96343H17.4488M13.5426 7.27112V11.593M14.9272 7.27112V6.53266M13.2773 4.8462H4.65081M3.00001 6.53082V15.4616M4.65081 17.1462H5.32672M14.2367 12.2844H19.8563" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const ICON_2DAY_16 = `<svg class="handling-option__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3631 16.4548C11.3413 17.535 10.4736 18.3949 9.42018 18.3801C8.36678 18.3653 7.5224 17.4814 7.52951 16.4009C7.53662 15.3204 8.39253 14.4482 9.44603 14.448C9.95972 14.4534 10.4503 14.6678 10.8098 15.0441C11.1693 15.4205 11.3683 15.9279 11.3631 16.4548Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4936 16.4548C20.4718 17.535 19.6041 18.3949 18.5507 18.3801C17.4973 18.3653 16.653 17.4814 16.6601 16.4009C16.6672 15.3204 17.523 14.4482 18.5766 14.448C19.0902 14.4534 19.5809 14.6678 19.9403 15.0441C20.2998 15.4205 20.4989 15.9279 20.4936 16.4548Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.4337 15.7625H11.3631M17.1296 16.4548V11.593M16.4373 17.1471H16.6632M20.5122 17.1469C22.0501 17.1136 23.2422 15.8161 23.2153 14.2817M23.2051 14.1753L22.7354 11.4744M16.4336 7.96343H19.6476M15.7413 7.27112V11.593M17.1259 7.27112V6.53266M15.476 4.8462H6.84957M5.19877 6.53082V15.4616M6.84957 17.1462H7.52548M16.4355 12.2844H22.0551M0.923077 8.07697H3.74008M1.82308 10.8462H3.62308M2.37208 13.6154H3.62308" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const ICON_EXPRESS_16 = `<svg class="handling-option__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19.7355 7.22903C19.7355 7.22903 20.8527 5.51783 19.7921 4.45717C18.7314 3.39651 17.0202 4.51374 17.0202 4.51374L13.4847 8.04927L5.88562 5.63568L4 7.5213L10.1848 11.3491L8.29921 13.2347L4.82967 13.5364L4.12257 14.2435L7.77124 16.478L10.034 20.1549L10.7411 19.4478L11.0145 15.95L12.9001 14.0644L16.7279 20.2492L18.6135 18.3636L16.2 10.7646L19.7355 7.22903Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>`;


class CustomProductForm extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this._observers = [];
    this.minimumDate = null;
    this.courseSearchAbort = null;
    this.hasConfirmedBags = false;
    this.hasBuiltLayout = false;
  }

  async connectedCallback() {
    if (this._initialized) return;

    this._initialized = true;
    
    // Cache critical DOM queries immediately
    this.submitButton = this.querySelector(".product-form__submit");
    const submitSpinner = this.submitButton?.querySelector(".loading-overlay__spinner");
    if (submitSpinner) submitSpinner.remove();
    this.form = this.querySelector("form");
    this.destinationField = this.querySelector("#destination");
    this.originField = this.querySelector('[name="origin"]');
    this.modal = this.querySelector("#address-modal");
    // Move modal to body to avoid layout shifts
    if (this.modal && this.modal.parentNode !== document.body) {
      document.body.appendChild(this.modal);
    }
    this.inputAddress = document.getElementById("input-address");
    this.inputPostcode = document.getElementById("input-postcode");
    this.inputCity = document.getElementById("input-city");
    this.inputState = document.getElementById("input-state");
    this.inputCompany = document.getElementById("input-company");
    this.inputAddress2 = document.getElementById("input-address2");
    this.modalButtonWrapper = document.querySelector("[data-modal-button-wrapper]");
    this.saveAddressButton = document.querySelector("[data-save-address-button]");
    this.overlay = this.querySelector(".loading-overlay__spinner");
    this.homeHandlingPriceEl = this.querySelector("[data-handling-price-home]");
    this.dropoffHandlingPriceEl = this.querySelector(
      "[data-handling-price-dropoff]",
    );
    
    // Initialize cart drawer/notification
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    if (this.cart && document.querySelector("cart-drawer")) {
      this.submitButton.setAttribute("aria-haspopup", "dialog");
    }
    
    // Initialize simple properties
    this.submitButton.setAttribute("data-disabled", true);
    this.postalCode = null;
    this.map = null;
    this.marker = null;
    this.geocoder = null;
    this.currentEditingInput = null;
    this.selectedServiceId = null;
    this.lastServicesData = [];
    this.shippingData = null;
    this.selectedOutboundServiceCode = null;
    this.selectedReturnServiceCode = null;
    this.skipNextRateCall = false;
    this.leadTimePromise = null;
    this.deferredInitStarted = false;
    this.serviceLabelMap = {
      FEDEX_GROUND: "Ground",
      FEDEX_2_DAY: "Two Day Express",
      PRIORITY_OVERNIGHT: "Overnight Express",
    };

    // Override icons with shared constants (avoid duplicate inline SVG parsing)
    this.iconGround = ICON_GROUND;
    this.icon2Day = ICON_2DAY;
    this.iconExpress = ICON_EXPRESS;
    this.iconReturn = ICON_RETURN;
    this.iconGround16 = ICON_GROUND_16;
    this.icon2Day16 = ICON_2DAY_16;
    this.iconExpress16 = ICON_EXPRESS_16;

    // Shipping summary icons (24x24)
    this.iconGround = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.16431 16.4548C9.14253 17.535 8.27484 18.3949 7.22142 18.3801C6.16802 18.3653 5.32364 17.4814 5.33075 16.4009C5.33786 15.3204 6.19377 14.4482 7.24727 14.448C7.76096 14.4534 8.25158 14.6678 8.61102 15.0441C8.97056 15.4205 9.16958 15.9279 9.16431 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2949 16.4548C18.2731 17.535 17.4054 18.3949 16.352 18.3801C15.2985 18.3653 14.4542 17.4814 14.4613 16.4009C14.4684 15.3204 15.3243 14.4482 16.3778 14.448C16.8915 14.4534 17.3821 14.6678 17.7416 15.0441C18.1011 15.4205 18.3001 15.9279 18.2949 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.235 17.1471C14.6173 17.1471 14.9273 16.8372 14.9273 16.4548C14.9273 16.0725 14.6173 15.7625 14.235 15.7625V17.1471ZM9.16432 15.7625C8.78198 15.7625 8.47201 16.0725 8.47201 16.4548C8.47201 16.8372 8.78198 17.1471 9.16432 17.1471V15.7625ZM13.5463 16.4548C13.5463 16.8372 13.8561 17.1471 14.2386 17.1471C14.6209 17.1471 14.9309 16.8372 14.9309 16.4548H13.5463ZM14.9309 11.593C14.9309 11.2106 14.6209 10.9007 14.2386 10.9007C13.8561 10.9007 13.5463 11.2106 13.5463 11.593H14.9309ZM14.2386 15.7625C13.8561 15.7625 13.5463 16.0725 13.5463 16.4548C13.5463 16.8372 13.8561 17.1471 14.2386 17.1471V15.7625ZM14.4644 17.1471C14.8468 17.1471 15.1567 16.8372 15.1567 16.4548C15.1567 16.0725 14.8468 15.7625 14.4644 15.7625V17.1471ZM18.2834 15.7627C17.9011 15.771 17.598 16.0875 17.6063 16.4699C17.6145 16.8521 17.9311 17.1552 18.3134 17.1469L18.2834 15.7627ZM20.3243 14.2939L21.0165 14.2817C21.0159 14.246 21.0125 14.2104 21.0064 14.1753L20.3243 14.2939ZM20.5366 11.4744C20.4711 11.0976 20.1126 10.8454 19.7359 10.9109C19.3591 10.9764 19.107 11.3349 19.1724 11.7116L20.5366 11.4744ZM14.2349 6.57882C13.8525 6.57882 13.5426 6.88878 13.5426 7.27112C13.5426 7.65347 13.8525 7.96343 14.2349 7.96343V6.57882ZM17.4488 7.27112V7.96345L17.4533 7.96341L17.4488 7.27112ZM19.4783 9.43205L18.7867 9.40254C18.7845 9.45216 18.7878 9.50186 18.7963 9.55078L19.4783 9.43205ZM19.1724 11.7116C19.2379 12.0883 19.5966 12.3406 19.9733 12.275C20.35 12.2094 20.6023 11.851 20.5366 11.4744L19.1724 11.7116ZM14.9272 7.27112C14.9272 6.88878 14.6173 6.57882 14.2349 6.57882C13.8525 6.57882 13.5426 6.88878 13.5426 7.27112H14.9272ZM13.5426 11.593C13.5426 11.9753 13.8525 12.2853 14.2349 12.2853C14.6173 12.2853 14.9272 11.9753 14.9272 11.593H13.5426ZM13.5426 7.27112C13.5426 7.65347 13.8525 7.96343 14.2349 7.96343C14.6173 7.96343 14.9272 7.65347 14.9272 7.27112H13.5426ZM14.2349 6.53266L13.5426 6.52823V6.53266H14.2349ZM13.2773 5.53851L13.2812 4.8462H13.2773V5.53851ZM4.65081 5.53851V4.84619L4.64751 4.84621L4.65081 5.53851ZM3.69232 6.53082H4.38463L4.38461 6.52766L3.69232 6.53082ZM3.69232 15.4616L4.38462 15.4647V15.4616H3.69232ZM4.65081 16.4539L4.64751 17.1462H4.65081V16.4539ZM5.32672 17.1462C5.70906 17.1462 6.01902 16.8362 6.01902 16.4539C6.01902 16.0716 5.70906 15.7616 5.32672 15.7616V17.1462ZM14.2367 10.8997C13.8544 10.8997 13.5444 11.2097 13.5444 11.592C13.5444 11.9744 13.8544 12.2844 14.2367 12.2844V10.8997ZM19.8563 12.2844C20.2387 12.2844 20.5486 11.9744 20.5486 11.592C20.5486 11.2097 20.2387 10.8997 19.8563 10.8997V12.2844ZM14.235 15.7625H9.16432V17.1471H14.235V15.7625ZM14.9309 16.4548V11.593H13.5463V16.4548H14.9309ZM14.2386 17.1471H14.4644V15.7625H14.2386V17.1471ZM18.3134 17.1469C19.8513 17.1136 21.0435 15.8161 21.0165 14.2817L19.6321 14.3061C19.6463 15.1112 19.0264 15.7465 18.2834 15.7627L18.3134 17.1469ZM21.0064 14.1753L20.5366 11.4744L19.1724 11.7116L19.6423 14.4125L21.0064 14.1753ZM14.2349 7.96343L17.4488 7.96345V6.57882H14.2349V7.96343ZM17.4533 7.96341C17.8106 7.96111 18.1571 8.109 18.4108 8.3791L19.4201 7.4312C18.9066 6.88445 18.1928 6.57399 17.4443 6.57883L17.4533 7.96341ZM18.4108 8.3791C18.6651 8.64988 18.803 9.01962 18.7867 9.40254L20.17 9.46156C20.202 8.71138 19.9329 7.97728 19.4201 7.4312L18.4108 8.3791ZM18.7963 9.55078L19.1724 11.7116L20.5366 11.4744L20.1604 9.31331L18.7963 9.55078ZM13.5426 7.27112V11.593H14.9272V7.27112H13.5426ZM14.9272 7.27112V6.53266H13.5426V7.27112H14.9272ZM14.9272 6.53709C14.93 6.09683 14.7623 5.67013 14.4556 5.35175L13.4584 6.31231C13.5109 6.36688 13.543 6.44426 13.5426 6.52823L14.9272 6.53709ZM14.4556 5.35175C14.1484 5.03277 13.7263 4.84875 13.2812 4.8462L13.2734 6.23081C13.3395 6.23119 13.4064 6.25836 13.4584 6.31231L14.4556 5.35175ZM13.2773 4.8462L4.65081 4.84619V6.23082H13.2773V4.8462ZM4.64751 4.84621C4.20276 4.84833 3.78075 5.03172 3.47324 5.35008L4.46913 6.31204C4.52114 6.2582 4.58807 6.23112 4.65413 6.23081L4.64751 4.84621ZM3.47324 5.35008C3.16631 5.66783 2.99801 6.09399 3.00002 6.53398L4.38461 6.52766C4.38424 6.44373 4.41655 6.36647 4.46913 6.31204L3.47324 5.35008ZM3.00001 6.53082V15.4616H4.38462L4.38463 6.53082H3.00001ZM3.00002 15.4584C2.99801 15.8984 3.16631 16.3246 3.47324 16.6423L4.46913 15.6804C4.41655 15.6259 4.38425 15.5486 4.38462 15.4647L3.00002 15.4584ZM3.47324 16.6423C3.78075 16.9607 4.20276 17.1441 4.64751 17.1462L4.65413 15.7616C4.58807 15.7613 4.52113 15.7342 4.46913 15.6804L3.47324 16.6423ZM4.65081 17.1462H5.32672V15.7616H4.65081V17.1462ZM14.2367 12.2844H19.8563V10.8997H14.2367V12.2844Z" fill="black"/></svg>`;
    this.icon2Day = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3631 16.4548C11.3413 17.535 10.4736 18.3949 9.42018 18.3801C8.36678 18.3653 7.5224 17.4814 7.52951 16.4009C7.53662 15.3204 8.39253 14.4482 9.44603 14.448C9.95972 14.4534 10.4503 14.6678 10.8098 15.0441C11.1693 15.4205 11.3683 15.9279 11.3631 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4936 16.4548C20.4718 17.535 19.6041 18.3949 18.5507 18.3801C17.4973 18.3653 16.653 17.4814 16.6601 16.4009C16.6672 15.3204 17.523 14.4482 18.5766 14.448C19.0902 14.4534 19.5809 14.6678 19.9403 15.0441C20.2998 15.4205 20.4989 15.9279 20.4936 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.4337 17.1471C16.8161 17.1471 17.126 16.8372 17.126 16.4548C17.126 16.0725 16.8161 15.7625 16.4337 15.7625V17.1471ZM11.3631 15.7625C10.9807 15.7625 10.6708 16.0725 10.6708 16.4548C10.6708 16.8372 10.9807 17.1471 11.3631 17.1471V15.7625ZM15.745 16.4548C15.745 16.8372 16.0549 17.1471 16.4373 17.1471C16.8197 17.1471 17.1296 16.8372 17.1296 16.4548H15.745ZM17.1296 11.593C17.1296 11.2106 16.8197 10.9007 16.4373 10.9007C16.0549 10.9007 15.745 11.2106 15.745 11.593H17.1296ZM16.4373 15.7625C16.0549 15.7625 15.745 16.0725 15.745 16.4548C15.745 16.8372 16.0549 17.1471 16.4373 17.1471V15.7625ZM16.6632 17.1471C17.0455 17.1471 17.3555 16.8372 17.3555 16.4548C17.3555 16.0725 17.0455 15.7625 16.6632 15.7625V17.1471ZM20.4822 15.7627C20.0999 15.771 19.7968 16.0875 19.8051 16.4699C19.8133 16.8521 20.1299 17.1552 20.5122 17.1469L20.4822 15.7627ZM22.5231 14.2939L23.2153 14.2817C23.2146 14.246 23.2112 14.2104 23.2051 14.1753L22.5231 14.2939ZM22.7354 11.4744C22.6698 11.0976 22.3113 10.8454 21.9346 10.9109C21.5579 10.9764 21.3057 11.3349 21.3712 11.7116L22.7354 11.4744ZM16.4336 6.57882C16.0513 6.57882 15.7413 6.88878 15.7413 7.27112C15.7413 7.65347 16.0513 7.96343 16.4336 7.96343V6.57882ZM19.6476 7.27112V7.96345L19.652 7.96341L19.6476 7.27112ZM21.6771 9.43205L20.9854 9.40254C20.9833 9.45216 20.9865 9.50186 20.995 9.55078L21.6771 9.43205ZM21.3712 11.7116C21.4367 12.0883 21.7953 12.3406 22.172 12.275C22.5487 12.2094 22.801 11.851 22.7354 11.4744L21.3712 11.7116ZM17.1259 7.27112C17.1259 6.88878 16.8161 6.57882 16.4336 6.57882C16.0513 6.57882 15.7413 6.88878 15.7413 7.27112H17.1259ZM15.7413 11.593C15.7413 11.9753 16.0513 12.2853 16.4336 12.2853C16.8161 12.2853 17.1259 11.9753 17.1259 11.593H15.7413ZM15.7413 7.27112C15.7413 7.65347 16.0513 7.96343 16.4336 7.96343C16.8161 7.96343 17.1259 7.65347 17.1259 7.27112H15.7413ZM16.4336 6.53266L15.7413 6.52823V6.53266H16.4336ZM15.476 5.53851L15.48 4.8462H15.476V5.53851ZM6.84957 5.53851V4.84619L6.84627 4.84621L6.84957 5.53851ZM5.89108 6.53082H6.58339L6.58338 6.52766L5.89108 6.53082ZM5.89108 15.4616L6.58339 15.4647V15.4616H5.89108ZM6.84957 16.4539L6.84627 17.1462H6.84957V16.4539ZM7.52548 17.1462C7.90783 17.1462 8.21779 16.8362 8.21779 16.4539C8.21779 16.0716 7.90783 15.7616 7.52548 15.7616V17.1462ZM16.4355 10.8997C16.0531 10.8997 15.7432 11.2097 15.7432 11.592C15.7432 11.9744 16.0531 12.2844 16.4355 12.2844V10.8997ZM22.0551 12.2844C22.4374 12.2844 22.7474 11.9744 22.7474 11.592C22.7474 11.2097 22.4374 10.8997 22.0551 10.8997V12.2844ZM0.923077 6.69235C0.540726 6.69235 0.23077 7.00231 0.23077 7.38466C0.23077 7.76701 0.540726 8.07697 0.923077 8.07697V6.69235ZM3.74008 8.07697C4.12243 8.07697 4.43239 7.76701 4.43239 7.38466C4.43239 7.00231 4.12243 6.69235 3.74008 6.69235V8.07697ZM1.82308 9.46159C1.44073 9.46159 1.13077 9.77155 1.13077 10.1539C1.13077 10.5362 1.44073 10.8462 1.82308 10.8462V9.46159ZM3.62308 10.8462C4.00542 10.8462 4.31539 10.5362 4.31539 10.1539C4.31539 9.77155 4.00542 9.46159 3.62308 9.46159V10.8462ZM2.37208 12.2308C1.98973 12.2308 1.67977 12.5408 1.67977 12.9231C1.67977 13.3055 1.98973 13.6154 2.37208 13.6154V12.2308ZM3.62308 13.6154C4.00542 13.6154 4.31539 13.3055 4.31539 12.9231C4.31539 12.5408 4.00542 12.2308 3.62308 12.2308V13.6154ZM16.4337 15.7625H11.3631V17.1471H16.4337V15.7625ZM17.1296 16.4548V11.593H15.745V16.4548H17.1296ZM16.4373 17.1471H16.6632V15.7625H16.4373V17.1471ZM20.5122 17.1469C22.0501 17.1136 23.2422 15.8161 23.2153 14.2817L21.8309 14.3061C21.8451 15.1112 21.2251 15.7465 20.4822 15.7627L20.5122 17.1469ZM23.2051 14.1753L22.7354 11.4744L21.3712 11.7116L21.841 14.4125L23.2051 14.1753ZM16.4336 7.96343L19.6476 7.96345V6.57882H16.4336V7.96343ZM19.652 7.96341C20.0094 7.96111 20.3559 8.109 20.6095 8.3791L21.6188 7.4312C21.1053 6.88445 20.3916 6.57399 19.6431 6.57883L19.652 7.96341ZM20.6095 8.3791C20.8638 8.64988 21.0018 9.01962 20.9854 9.40254L22.3687 9.46156C22.4008 8.71138 22.1317 7.97728 21.6188 7.4312L20.6095 8.3791ZM20.995 9.55078L21.3712 11.7116L22.7354 11.4744L22.3591 9.31331L20.995 9.55078ZM15.7413 7.27112V11.593H17.1259V7.27112H15.7413ZM17.1259 7.27112V6.53266H15.7413V7.27112H17.1259ZM17.1259 6.53709C17.1288 6.09683 16.9611 5.67013 16.6543 5.35175L15.6571 6.31231C15.7097 6.36688 15.7418 6.44426 15.7413 6.52823L17.1259 6.53709ZM16.6543 5.35175C16.3471 5.03277 15.9251 4.84875 15.48 4.8462L15.4722 6.23081C15.5382 6.23119 15.6052 6.25836 15.6571 6.31231L16.6543 5.35175ZM15.476 4.8462L6.84957 4.84619V6.23082H15.476V4.8462ZM6.84627 4.84621C6.40152 4.84833 5.97951 5.03172 5.672 5.35008L6.66789 6.31204C6.7199 6.2582 6.78683 6.23112 6.85289 6.23081L6.84627 4.84621ZM5.672 5.35008C5.36507 5.66783 5.19677 6.09399 5.19878 6.53398L6.58338 6.52766C6.583 6.44373 6.61531 6.36647 6.66789 6.31204L5.672 5.35008ZM5.19877 6.53082V15.4616H6.58339L6.58339 6.53082H5.19877ZM5.19878 15.4584C5.19677 15.8984 5.36507 16.3246 5.672 16.6423L6.66789 15.6804C6.61531 15.6259 6.58301 15.5486 6.58339 15.4647L5.19878 15.4584ZM5.672 16.6423C5.97951 16.9607 6.40152 17.1441 6.84627 17.1462L6.85289 15.7616C6.78683 15.7613 6.71989 15.7342 6.66789 15.6804L5.672 16.6423ZM6.84957 17.1462H7.52548V15.7616H6.84957V17.1462ZM16.4355 12.2844H22.0551V10.8997H16.4355V12.2844ZM0.923077 8.07697H3.74008V6.69235H0.923077V8.07697ZM1.82308 10.8462H3.62308V9.46159H1.82308V10.8462ZM2.37208 13.6154H3.62308V12.2308H2.37208V13.6154Z" fill="black"/></svg>`;
    this.icon2Day = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3631 16.4548C11.3413 17.535 10.4736 18.3949 9.42018 18.3801C8.36678 18.3653 7.5224 17.4814 7.52951 16.4009C7.53662 15.3204 8.39253 14.4482 9.44603 14.448C9.95972 14.4534 10.4503 14.6678 10.8098 15.0441C11.1693 15.4205 11.3683 15.9279 11.3631 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4936 16.4548C20.4718 17.535 19.6041 18.3949 18.5507 18.3801C17.4973 18.3653 16.653 17.4814 16.6601 16.4009C16.6672 15.3204 17.523 14.4482 18.5766 14.448C19.0902 14.4534 19.5809 14.6678 19.9403 15.0441C20.2998 15.4205 20.4989 15.9279 20.4936 16.4548Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.4337 17.1471C16.8161 17.1471 17.126 16.8372 17.126 16.4548C17.126 16.0725 16.8161 15.7625 16.4337 15.7625V17.1471ZM11.3631 15.7625C10.9807 15.7625 10.6708 16.0725 10.6708 16.4548C10.6708 16.8372 10.9807 17.1471 11.3631 17.1471V15.7625ZM15.745 16.4548C15.745 16.8372 16.0549 17.1471 16.4373 17.1471C16.8197 17.1471 17.1296 16.8372 17.1296 16.4548H15.745ZM17.1296 11.593C17.1296 11.2106 16.8197 10.9007 16.4373 10.9007C16.0549 10.9007 15.745 11.2106 15.745 11.593H17.1296ZM16.4373 15.7625C16.0549 15.7625 15.745 16.0725 15.745 16.4548C15.745 16.8372 16.0549 17.1471 16.4373 17.1471V15.7625ZM16.6632 17.1471C17.0455 17.1471 17.3555 16.8372 17.3555 16.4548C17.3555 16.0725 17.0455 15.7625 16.6632 15.7625V17.1471ZM20.4822 15.7627C20.0999 15.771 19.7968 16.0875 19.8051 16.4699C19.8133 16.8521 20.1299 17.1552 20.5122 17.1469L20.4822 15.7627ZM22.5231 14.2939L23.2153 14.2817C23.2146 14.246 23.2112 14.2104 23.2051 14.1753L22.5231 14.2939ZM22.7354 11.4744C22.6698 11.0976 22.3113 10.8454 21.9346 10.9109C21.5579 10.9764 21.3057 11.3349 21.3712 11.7116L22.7354 11.4744ZM16.4336 6.57882C16.0513 6.57882 15.7413 6.88878 15.7413 7.27112C15.7413 7.65347 16.0513 7.96343 16.4336 7.96343V6.57882ZM19.6476 7.27112V7.96345L19.652 7.96341L19.6476 7.27112ZM21.6771 9.43205L20.9854 9.40254C20.9833 9.45216 20.9865 9.50186 20.995 9.55078L21.6771 9.43205ZM21.3712 11.7116C21.4367 12.0883 21.7953 12.3406 22.172 12.275C22.5487 12.2094 22.801 11.851 22.7354 11.4744L21.3712 11.7116ZM17.1259 7.27112C17.1259 6.88878 16.8161 6.57882 16.4336 6.57882C16.0513 6.57882 15.7413 6.88878 15.7413 7.27112H17.1259ZM15.7413 11.593C15.7413 11.9753 16.0513 12.2853 16.4336 12.2853C16.8161 12.2853 17.1259 11.9753 17.1259 11.593H15.7413ZM15.7413 7.27112C15.7413 7.65347 16.0513 7.96343 16.4336 7.96343C16.8161 7.96343 17.1259 7.65347 17.1259 7.27112H15.7413ZM16.4336 6.53266L15.7413 6.52823V6.53266H16.4336ZM15.476 5.53851L15.48 4.8462H15.476V5.53851ZM6.84957 5.53851V4.84619L6.84627 4.84621L6.84957 5.53851ZM5.89108 6.53082H6.58339L6.58338 6.52766L5.89108 6.53082ZM5.89108 15.4616L6.58339 15.4647V15.4616H5.89108ZM6.84957 16.4539L6.84627 17.1462H6.84957V16.4539ZM7.52548 17.1462C7.90783 17.1462 8.21779 16.8362 8.21779 16.4539C8.21779 16.0716 7.90783 15.7616 7.52548 15.7616V17.1462ZM16.4355 10.8997C16.0531 10.8997 15.7432 11.2097 15.7432 11.592C15.7432 11.9744 16.0531 12.2844 16.4355 12.2844V10.8997ZM22.0551 12.2844C22.4374 12.2844 22.7474 11.9744 22.7474 11.592C22.7474 11.2097 22.4374 10.8997 22.0551 10.8997V12.2844ZM0.923077 6.69235C0.540726 6.69235 0.23077 7.00231 0.23077 7.38466C0.23077 7.76701 0.540726 8.07697 0.923077 8.07697V6.69235ZM3.74008 8.07697C4.12243 8.07697 4.43239 7.76701 4.43239 7.38466C4.43239 7.00231 4.12243 6.69235 3.74008 6.69235V8.07697ZM1.82308 9.46159C1.44073 9.46159 1.13077 9.77155 1.13077 10.1539C1.13077 10.5362 1.44073 10.8462 1.82308 10.8462V9.46159ZM3.62308 10.8462C4.00542 10.8462 4.31539 10.5362 4.31539 10.1539C4.31539 9.77155 4.00542 9.46159 3.62308 9.46159V10.8462ZM2.37208 12.2308C1.98973 12.2308 1.67977 12.5408 1.67977 12.9231C1.67977 13.3055 1.98973 13.6154 2.37208 13.6154V12.2308ZM3.62308 13.6154C4.00542 13.6154 4.31539 13.3055 4.31539 12.9231C4.31539 12.5408 4.00542 12.2308 3.62308 12.2308V13.6154ZM16.4337 15.7625H11.3631V17.1471H16.4337V15.7625ZM17.1296 16.4548V11.593H15.745V16.4548H17.1296ZM16.4373 17.1471H16.6632V15.7625H16.4373V17.1471ZM20.5122 17.1469C22.0501 17.1136 23.2422 15.8161 23.2153 14.2817L21.8309 14.3061C21.8451 15.1112 21.2251 15.7465 20.4822 15.7627L20.5122 17.1469ZM23.2051 14.1753L22.7354 11.4744L21.3712 11.7116L21.841 14.4125L23.2051 14.1753ZM16.4336 7.96343L19.6476 7.96345V6.57882H16.4336V7.96343ZM19.652 7.96341C20.0094 7.96111 20.3559 8.109 20.6095 8.3791L21.6188 7.4312C21.1053 6.88445 20.3916 6.57399 19.6431 6.57883L19.652 7.96341ZM20.6095 8.3791C20.8638 8.64988 21.0018 9.01962 20.9854 9.40254L22.3687 9.46156C22.4008 8.71138 22.1317 7.97728 21.6188 7.4312L20.6095 8.3791ZM20.995 9.55078L21.3712 11.7116L22.7354 11.4744L22.3591 9.31331L20.995 9.55078ZM15.7413 7.27112V11.593H17.1259V7.27112H15.7413ZM17.1259 7.27112V6.53266H15.7413V7.27112H17.1259ZM17.1259 6.53709C17.1288 6.09683 16.9611 5.67013 16.6543 5.35175L15.6571 6.31231C15.7097 6.36688 15.7418 6.44426 15.7413 6.52823L17.1259 6.53709ZM16.6543 5.35175C16.3471 5.03277 15.9251 4.84875 15.48 4.8462L15.4722 6.23081C15.5382 6.23119 15.6052 6.25836 15.6571 6.31231L16.6543 5.35175ZM15.476 4.8462L6.84957 4.84619V6.23082H15.476V4.8462ZM6.84627 4.84621C6.40152 4.84833 5.97951 5.03172 5.672 5.35008L6.66789 6.31204C6.7199 6.2582 6.78683 6.23112 6.85289 6.23081L6.84627 4.84621ZM5.672 5.35008C5.36507 5.66783 5.19677 6.09399 5.19878 6.53398L6.58338 6.52766C6.583 6.44373 6.61531 6.36647 6.66789 6.31204L5.672 5.35008ZM5.19877 6.53082V15.4616H6.58339L6.58339 6.53082H5.19877ZM5.19878 15.4584C5.19677 15.8984 5.36507 16.3246 5.672 16.6423L6.66789 15.6804C6.61531 15.6259 6.58301 15.5486 6.58339 15.4647L5.19878 15.4584ZM5.672 16.6423C5.97951 16.9607 6.40152 17.1441 6.84627 17.1462L6.85289 15.7616C6.78683 15.7613 6.71989 15.7342 6.66789 15.6804L5.672 16.6423ZM6.84957 17.1462H7.52548V15.7616H6.84957V17.1462ZM16.4355 12.2844H22.0551V10.8997H16.4355V12.2844ZM0.923077 8.07697H3.74008V6.69235H0.923077V8.07697ZM1.82308 10.8462H3.62308V9.46159H1.82308V10.8462ZM2.37208 13.6154H3.62308V12.2308H2.37208V13.6154Z" fill="black"/></svg>`;
    this.iconExpress = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.7355 7.22903C19.7355 7.22903 20.8527 5.51783 19.7921 4.45717C18.7314 3.39651 17.0202 4.51374 17.0202 4.51374L13.4847 8.04927L5.88562 5.63568L4 7.5213L10.1848 11.3491L8.29921 13.2347L4.82967 13.5364L4.12257 14.2435L7.77124 16.478L10.034 20.1549L10.7411 19.4478L11.0145 15.95L12.9001 14.0644L16.7279 20.2492L18.6135 18.3636L16.2 10.7646L19.7355 7.22903Z" stroke="black" stroke-width="1.2" stroke-linejoin="round"/></svg>`;
    this.iconReturn = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter"><path d="M19,8 L19,11 C19,12.1045695 18.1045695,13 17,13 L6,13"/><polyline points="8 16 5 13 8 10"/></svg>`;

    // Service selector icons (16x16) - same as delivery icons but smaller
    this.iconGround16 = `<svg class="handling-option__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.16431 16.4548C9.14253 17.535 8.27484 18.3949 7.22142 18.3801C6.16802 18.3653 5.32364 17.4814 5.33075 16.4009C5.33786 15.3204 6.19377 14.4482 7.24727 14.448C7.76096 14.4534 8.25158 14.6678 8.61102 15.0441C8.97056 15.4205 9.16958 15.9279 9.16431 16.4548Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2949 16.4548C18.2731 17.535 17.4054 18.3949 16.352 18.3801C15.2985 18.3653 14.4542 17.4814 14.4613 16.4009C14.4684 15.3204 15.3243 14.4482 16.3778 14.448C16.8915 14.4534 17.3821 14.6678 17.7416 15.0441C18.1011 15.4205 18.3001 15.9279 18.2949 16.4548Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.235 15.7625H9.16432M14.9309 16.4548V11.593M14.2386 17.1471H14.4644M18.3134 17.1469C19.8513 17.1136 21.0435 15.8161 21.0165 14.2817M21.0064 14.1753L20.5366 11.4744M14.2349 7.96343H17.4488M13.5426 7.27112V11.593M14.9272 7.27112V6.53266M13.2773 4.8462H4.65081M3.00001 6.53082V15.4616M4.65081 17.1462H5.32672M14.2367 12.2844H19.8563" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    this.icon2Day16 = `<svg class="handling-option__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3631 16.4548C11.3413 17.535 10.4736 18.3949 9.42018 18.3801C8.36678 18.3653 7.5224 17.4814 7.52951 16.4009C7.53662 15.3204 8.39253 14.4482 9.44603 14.448C9.95972 14.4534 10.4503 14.6678 10.8098 15.0441C11.1693 15.4205 11.3683 15.9279 11.3631 16.4548Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4936 16.4548C20.4718 17.535 19.6041 18.3949 18.5507 18.3801C17.4973 18.3653 16.653 17.4814 16.6601 16.4009C16.6672 15.3204 17.523 14.4482 18.5766 14.448C19.0902 14.4534 19.5809 14.6678 19.9403 15.0441C20.2998 15.4205 20.4989 15.9279 20.4936 16.4548Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.4337 15.7625H11.3631M17.1296 16.4548V11.593M16.4373 17.1471H16.6632M20.5122 17.1469C22.0501 17.1136 23.2422 15.8161 23.2153 14.2817M23.2051 14.1753L22.7354 11.4744M16.4336 7.96343H19.6476M15.7413 7.27112V11.593M17.1259 7.27112V6.53266M15.476 4.8462H6.84957M5.19877 6.53082V15.4616M6.84957 17.1462H7.52548M16.4355 12.2844H22.0551M0.923077 8.07697H3.74008M1.82308 10.8462H3.62308M2.37208 13.6154H3.62308" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    this.iconExpress16 = `<svg class="handling-option__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19.7355 7.22903C19.7355 7.22903 20.8527 5.51783 19.7921 4.45717C18.7314 3.39651 17.0202 4.51374 17.0202 4.51374L13.4847 8.04927L5.88562 5.63568L4 7.5213L10.1848 11.3491L8.29921 13.2347L4.82967 13.5364L4.12257 14.2435L7.77124 16.478L10.034 20.1549L10.7411 19.4478L11.0145 15.95L12.9001 14.0644L16.7279 20.2492L18.6135 18.3636L16.2 10.7646L19.7355 7.22903Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>`;
    
    this.buildJourneyLayout();
    this.setupBagTypeModal();

    // Defer heavy DOM queries to next frame (not immediately needed)
    requestAnimationFrame(() => {
      this.returnCostEl = document.querySelector("[data-return-cost]");
      this.rentalCostEl = document.querySelector("[data-rental-cost]");
      this.shippingCostEl = document.querySelector("[data-shipping-cost]");
      this.homeCollectionCostEl = document.querySelector("[data-home-collection-cost]");
      this.totalEl = document.querySelector("[data-total]");
      this.serviceOptionsContainer =
        document.querySelector("[data-outbound-options]") ||
        document.querySelector("[data-service-options]");
      this.returnOptionsContainer = document.querySelector("[data-return-options]");
      this.shippingPriceInput = document.querySelector("[data-shipping-price]");
      this.shippingServiceInput = document.querySelector("[data-shipping-service]");
      this.shippingOutboundDateInput = document.querySelector("[data-shipping-outbound-date]");
      this.shippingReturnDateInput = document.querySelector("[data-shipping-return-date]");
      this.shippingSummaryContainer = document.querySelector("[data-shipping-summary]");
      this.summaryCard = document.querySelector("[data-summary-card]");
      this.outboundCard = this.querySelector("[data-outbound-card]");
      this.returnCard = this.querySelector("[data-return-card]");
      this.outboundSpinner = this.querySelector("[data-outbound-spinner]");
      this.returnSpinner = this.querySelector("[data-return-spinner]");
      this.outboundDeliverBy = this.querySelector("[data-outbound-deliver-by]");
      this.returnCollectionOn = this.querySelector("[data-return-collection-on]");
      this.confirmBagsButton = this.querySelector("[data-confirm-bags]");
      this.summaryExtras = this.querySelector("[data-summary-extras]");
      this.summaryMapEl = this.querySelector("[data-summary-map]");
      this.renderShippingSummaryPlaceholder();
      this.setupConfirmButton();
      this.setupConfirmBagsReconfirm();
    this.setupStickySummary();
      this.updateServiceDateCaptions();
      this.initSummaryMapWhenReady();
    });
    
    // Load bags without blocking (run in background)
    this.hideLoading();

    // Restore addresses from sessionStorage (fast, synchronous)
    this.restoreAddressesFromSession();

    // Set up modal close handler
    document.addEventListener("click", (e) => {
      const isInsideModal = this.modal
        .querySelector(".address-picker__modal-content-wrapper")
        ?.contains(e.target);
      const isEditTrigger = e.target.closest("[data-modal-edit]");
      const isAutocompleteUI = e.target.closest(".autocomplete-container") ||
                               e.target.closest("[data-autocomplete-toggle-destination]") ||
                               e.target.closest("[data-autocomplete-toggle-origin]");
      if (!isInsideModal && isEditTrigger == null && !isAutocompleteUI) {
        this.closeModal();
      }
      const activeField = document.activeElement;
      const isAddressField = activeField === this.originField || activeField === this.destinationField;
      const clickedInsideField = activeField?.contains?.(e.target);
      if (isAddressField && !isAutocompleteUI && !clickedInsideField) {
        activeField.blur();
      }
    });

    // Set up critical event listeners immediately
    this.setupCriticalListeners();
    this.setupHandlingSelector();
    this.setupAutocompleteToggle();
    this.setupCourseSearchListeners();
    this.setupAddressFieldResets();
    
    // Kick off minimum date fetch (non-blocking)
    this.fetchAndSetMinimumDate();
    
    // Defer heavy initializations to next frame
    requestAnimationFrame(() => {
      this.setupDatePicker();
      this.setupSaveAddressButton();
    });

    // Lazy-load autocomplete and cart data on first focus
    const triggerDeferredInit = () => this.triggerDeferredInit();
    this.destinationField?.addEventListener("focus", triggerDeferredInit, { once: true });
    this.originField?.addEventListener("focus", triggerDeferredInit, { once: true });

    window.addEventListener("load", () => {
      this.initSummaryMapWhenReady();
    });
  }

  triggerDeferredInit() {
    if (this.deferredInitStarted) return;
    this.deferredInitStarted = true;
    this.initGoogleAutocomplete();
    this.handleOnLoad();
  }

  async fetchAndSetMinimumDate() {
    try {
      const data = await GetClubsAPI.getSmcLeadTime();
      
      if (data.firstAvailableDate) {
        // Parse the YYYY-MM-DD date
        this.minimumDate = new Date(data.firstAvailableDate + 'T00:00:00');
      } else {
        throw new Error('No firstAvailableDate in response');
      }
    } catch (error) {
      console.error('Error fetching ship lead time:', error);
      // Fallback to tomorrow if API fails
      this.minimumDate = new Date();
      this.minimumDate.setDate(this.minimumDate.getDate() + 1);
      console.warn('Using fallback minimum date (tomorrow):', this.minimumDate);
    }
  }

  restoreAddressesFromSession() {
    const hasDestinationAddress = sessionStorage.getItem("refulfil:destination:address");
    if (hasDestinationAddress) {
      // Reconstruct the full address for display
      const company = sessionStorage.getItem("refulfil:destination:company");
      const address = sessionStorage.getItem("refulfil:destination:address");
      const address2 = sessionStorage.getItem("refulfil:destination:address2");
      const city = sessionStorage.getItem("refulfil:destination:city");
      const state = sessionStorage.getItem("refulfil:destination:state");
      const postal = sessionStorage.getItem("refulfil:destination:postal");
      const cityState = [city, state].filter(Boolean).join(", ");
      this.destinationField.value = [company, address, address2, cityState, postal].filter(Boolean).join(", ");
      this.destinationField.dataset.addressSelected = "true";
      
      if (this.destinationField.value && !this.destinationField.disabled) {
        requestAnimationFrame(() => {
          const editButton = this.destinationField.closest(".form-group")?.querySelector("[data-modal-edit]");
          if (editButton) editButton.classList.add("show");
          this.setupEditButtonListener(this.destinationField);
        });
      }
    }

    // Prefill origin from new session storage keys (align with destination handling)
    const originCompany = sessionStorage.getItem("refulfil:origin:company");
    const originAddress = sessionStorage.getItem("refulfil:origin:address");
    const originAddress2 = sessionStorage.getItem("refulfil:origin:address2");
    const originCity = sessionStorage.getItem("refulfil:origin:city");
    const originState = sessionStorage.getItem("refulfil:origin:state");
    const originPostal = sessionStorage.getItem("refulfil:origin:postal");

    // Legacy fallback (older single-key storage)
    const legacyOrigin = sessionStorage.getItem("refulfil:originAddress");

    if (this.originField) {
      const cityState = [originCity, originState].filter(Boolean).join(", ");
      const composedOrigin = [originCompany, originAddress, originAddress2, cityState, originPostal].filter(Boolean).join(", ");

      // Prefer new keys; if absent, fall back to legacy JSON string
      if (composedOrigin) {
        this.originField.value = composedOrigin;
        this.originField.dataset.addressSelected = "true";
      } else if (legacyOrigin) {
        // Legacy storage only ever held a flat display string — there are no
        // structured components to recover from it. Show it for reference but
        // mark the field unconfirmed so validateStructuredAddresses() forces a
        // fresh autocomplete selection (which repopulates refulfil:origin:*).
        // Without this, the field looked complete while getStoredOrigin()
        // returned blanks, producing quotes with an empty origin address.
        try {
          this.originField.value = JSON.parse(legacyOrigin);
          this.originField.dataset.addressSelected = "false";
        } catch (e) {
          sessionStorage.removeItem("refulfil:originAddress");
        }
      }

      if (this.originField.value) {
        requestAnimationFrame(() => {
          const editButton = this.originField.closest(".form-group")?.querySelector("[data-modal-edit]");
          if (editButton) editButton.classList.add("show");
          this.setupEditButtonListener(this.originField);
        });

        // Restore origin toggle mode based on whether a golf course was previously selected
        const originCourse = sessionStorage.getItem("refulfil:origin:course");
        const originToggle = document.querySelector("[data-autocomplete-toggle-origin]");
        if (originToggle && !originCourse) {
          // Previously selected a regular address — switch toggle to addresses mode
          this.setAutocompleteMode(this.originField, "addresses");
          this.setToggleMode("addresses", originToggle);
        }
      }
    }

    this.updateSummaryMapFromStorage();
    this.updateAddressCallout();
  }

  setupCriticalListeners() {
    // Only set up the absolutely essential listeners immediately
    this.form.addEventListener("input", (event) => {
      this.allFieldsCompleted(event);
    });
    this.form.addEventListener("change", (event) => {
      this.allFieldsCompleted(event);
    });

    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.handleFormSubmit();
    });

    this.debouncedGetFedexRates = this.debounce(
      this.getFedexRates.bind(this),
      1000,
    );
  }

  buildJourneyLayout() {
    if (this.hasBuiltLayout || !this.form) return;

    const inputsWrapper = this.form.querySelector(".pdp-form__inputs");
    const actionsWrapper = this.form.querySelector(".pdp-form__actions");
    if (!inputsWrapper || !actionsWrapper) return;

    const layout = document.createElement("div");
    layout.className = "smc-layout";
    const leftCol = document.createElement("div");
    leftCol.className = "smc-left";
    const rightCol = document.createElement("div");
    rightCol.className = "smc-right";
    const rightSticky = document.createElement("div");
    rightSticky.className = "smc-right__sticky";

    layout.appendChild(leftCol);
    layout.appendChild(rightCol);
    rightCol.appendChild(rightSticky);

    inputsWrapper.parentNode.insertBefore(layout, inputsWrapper);

    const makeCard = (title, extraClass = "") => {
      const card = document.createElement("div");
      card.className = `smc-card${extraClass ? ` ${extraClass}` : ""}`;
      const header = document.createElement("div");
      header.className = "smc-card__header";
      const headerContent = document.createElement("div");
      headerContent.className = "smc-card__header-content";
      const heading = document.createElement("h3");
      heading.className = "smc-card__title";
      heading.textContent = title;
      headerContent.appendChild(heading);
      header.appendChild(headerContent);
      const body = document.createElement("div");
      body.className = "smc-card__body";
      card.appendChild(header);
      card.appendChild(body);
      return { card, body, header, headerContent };
    };

    const originGroup = inputsWrapper.querySelector("#origin")?.closest(".form-group");
    const destinationGroup = inputsWrapper.querySelector("#destination")?.closest(".form-group");
    const dateGroup = inputsWrapper.querySelector("#delivery_date_display")?.closest(".form-group");
    const handlingGroup = inputsWrapper.querySelector(".handling-selector-wrapper");
    const serviceGroup = inputsWrapper.querySelector(".service-selector-wrapper");

    const addressCallout = inputsWrapper.querySelector("[data-address-callout]");

    const tripCard = makeCard("Trip locations and dates");
    if (originGroup) tripCard.body.appendChild(originGroup);
    if (destinationGroup) tripCard.body.appendChild(destinationGroup);
    if (addressCallout) tripCard.body.appendChild(addressCallout);
    if (dateGroup) tripCard.body.appendChild(dateGroup);
    leftCol.appendChild(tripCard.card);

    const bagCard = makeCard("Bag details");
    bagCard.header.classList.add("smc-card__header--between");
    const insuranceWrapper = actionsWrapper.querySelector(".insurance-wrapper");
    const quantityWrapper = actionsWrapper.querySelector(".quantity-wrapper");
    if (quantityWrapper) {
      const quantityInput = quantityWrapper.querySelector("quantity-input");
      if (quantityInput) {
        const quantityContainer = document.createElement("div");
        quantityContainer.className = "smc-quantity-inline";
        quantityInput.classList.add("smc-quantity-simple");
        const qtyInputEl = quantityInput.querySelector(".quantity__input");
        if (qtyInputEl) qtyInputEl.classList.add("smc-quantity-input");
        const label = quantityWrapper.querySelector(".quantity__label");
        if (label) label.remove();
        const minusBtn = quantityInput.querySelector('button[name="minus"]');
        const plusBtn = quantityInput.querySelector('button[name="plus"]');
        if (minusBtn) minusBtn.textContent = "-";
        if (plusBtn) plusBtn.textContent = "+";
        quantityContainer.appendChild(quantityInput);
        bagCard.headerContent.appendChild(quantityContainer);
      }
      if (insuranceWrapper) {
        const bagList = document.createElement("div");
        bagList.className = "smc-bag-list";
        bagList.appendChild(insuranceWrapper);
        bagCard.body.appendChild(bagList);
      }
      quantityWrapper.remove();
    }
    const confirmButton = document.createElement("button");
    confirmButton.type = "button";
    confirmButton.className = "button button--secondary smc-confirm-bags";
    confirmButton.setAttribute("data-confirm-bags", "");
    confirmButton.textContent = "Confirm bags and continue";
    bagCard.body.appendChild(confirmButton);
    leftCol.appendChild(bagCard.card);

    const outboundCard = makeCard("Outbound trip", "smc-card--collapsed");
    outboundCard.card.setAttribute("data-outbound-card", "");
    outboundCard.header.classList.add("smc-card__header--between");
    const outboundEmpty = document.createElement("p");
    outboundEmpty.className = "smc-card__subtext smc-card__empty";
    outboundEmpty.setAttribute("data-outbound-empty", "");
    outboundEmpty.textContent = "Confirm bags and continue to view rates";
    outboundCard.card.insertBefore(outboundEmpty, outboundCard.body);
    const outboundSpinner = document.createElement("div");
    outboundSpinner.className = "smc-card__spinner";
    outboundSpinner.setAttribute("data-outbound-spinner", "");
    outboundSpinner.setAttribute("aria-hidden", "true");
    outboundSpinner.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25" /><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"><animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"></animateTransform></path></svg>`;
    outboundCard.header.appendChild(outboundSpinner);
    if (handlingGroup) outboundCard.body.appendChild(handlingGroup);
    if (serviceGroup) {
      const outboundOptions = serviceGroup.querySelector(".handling-selector");
      if (outboundOptions) {
        outboundOptions.setAttribute("data-outbound-options", "");
      }
      const serviceLabel = serviceGroup.querySelector(".handling-selector-label");
      if (serviceLabel) {
        serviceLabel.classList.add("smc-service-label");
        const outboundSubtext = document.createElement("p");
        outboundSubtext.className = "smc-card__subtext";
        outboundSubtext.setAttribute("data-outbound-deliver-by", "");
        outboundSubtext.textContent = "All services will deliver on or before —";
        serviceLabel.insertAdjacentElement("afterend", outboundSubtext);
      }
      outboundCard.body.appendChild(serviceGroup);
    }
    leftCol.appendChild(outboundCard.card);

    const returnCard = makeCard("Return trip", "smc-card--collapsed");
    returnCard.card.setAttribute("data-return-card", "");
    returnCard.header.classList.add("smc-card__header--between");
    const returnSpinner = document.createElement("div");
    returnSpinner.className = "smc-card__spinner";
    returnSpinner.setAttribute("data-return-spinner", "");
    returnSpinner.setAttribute("aria-hidden", "true");
    returnSpinner.innerHTML = outboundSpinner.innerHTML;
    returnCard.header.appendChild(returnSpinner);
    const returnEmpty = document.createElement("p");
    returnEmpty.className = "smc-card__subtext smc-card__empty";
    returnEmpty.setAttribute("data-return-empty", "");
    returnEmpty.textContent = "Confirm bags and continue to view rates";
    returnCard.card.insertBefore(returnEmpty, returnCard.body);
    const returnGroup = document.createElement("div");
    returnGroup.className = "form-group service-selector-wrapper";
    returnGroup.innerHTML = `
      <label class="handling-selector-label smc-service-label">Service</label>
      <p class="smc-card__subtext" data-return-collection-on>All services will pick up on —</p>
      <div class="handling-selector" data-return-options>
        <div class="handling-option handling-option--placeholder">
          <div class="handling-option__content">
            <div class="handling-option__label-wrapper">
              <span class="handling-option__label">Select dates to view services</span>
            </div>
            <span class="handling-option__price"></span>
          </div>
          <span class="handling-option__description">Rates will appear here after you pick your dates.</span>
        </div>
      </div>`;
    returnCard.body.appendChild(returnGroup);
    leftCol.appendChild(returnCard.card);

    const summaryCard = document.createElement("div");
    summaryCard.className = "smc-card smc-card--summary";
    const mapEl = document.createElement("div");
    mapEl.id = "map";
    mapEl.className = "smc-map";
    mapEl.setAttribute("data-summary-map", "");
    summaryCard.appendChild(mapEl);
    const pdpRates = actionsWrapper.querySelector(".pdp-rates");
    if (pdpRates) {
      pdpRates.classList.add("show");
      const summary = pdpRates.querySelector(".pdp-rates__summary");
      if (summary) {
        const header = summary.querySelector(".pdp-rates__summary-header");
        if (header) header.classList.add("smc-card__header");
        const summaryTitle = summary.querySelector(".pdp-rates__summary-title");
        if (summaryTitle) summaryTitle.classList.add("smc-card__title");
        const summarySpinner = summary.querySelector(".pdp-rates__summary-spinner");
        const shippingSummary = summary.querySelector("[data-shipping-summary]");
        const pricingSummary = summary.querySelector(".pdp-rates__pricing-summary");
        const summaryTop = document.createElement("div");
        summaryTop.className = "smc-summary-top";
        if (header) summaryTop.appendChild(header);
        if (shippingSummary) summaryTop.appendChild(shippingSummary);
        const pricingCard = document.createElement("div");
        pricingCard.className = "smc-summary-card";
        if (summarySpinner) {
          summarySpinner.classList.add("smc-summary-spinner");
          pricingCard.appendChild(summarySpinner);
        }
        if (pricingSummary) pricingCard.appendChild(pricingSummary);
        summary.innerHTML = "";
        summary.appendChild(summaryTop);
        summary.appendChild(pricingCard);
      }
      summaryCard.appendChild(pdpRates);
    }
    const buyButtons = actionsWrapper.querySelector(".product-buy-buttons-wrapper");
    if (buyButtons) summaryCard.appendChild(buyButtons);
    rightSticky.appendChild(summaryCard);

    const extras = document.createElement("div");
    extras.className = "smc-right__extras";
    extras.setAttribute("data-summary-extras", "");
    rightSticky.appendChild(extras);

    const paymentCards = summaryCard.querySelector(".product-form-payment-cards");
    if (paymentCards) extras.appendChild(paymentCards);
    const affirmWidget = summaryCard.querySelector(".affirm-widget");
    if (affirmWidget) extras.appendChild(affirmWidget);

    inputsWrapper.remove();
    actionsWrapper.remove();
    this.hasBuiltLayout = true;
  }

  setupHandlingSelector() {
    const handlingOptions = this.querySelectorAll("[data-handling-option]");
    if (!handlingOptions.length) return;

    const updateActiveState = () => {
      handlingOptions.forEach((option) => {
        const input = option.querySelector('input[name="dropoff_strategy"]');
        option.classList.toggle("active", !!input?.checked);
      });
    };

    handlingOptions.forEach((option) => {
      const input = option.querySelector('input[name="dropoff_strategy"]');
      if (!input || input._handlingListenerAttached) return;

      input._handlingListenerAttached = true;
      input.addEventListener("change", () => {
        updateActiveState();
        if (this.shippingData) {
          this.updatePricingAndSummary();
          this.renderOutboundOptions(true);
          this.renderReturnOptions(true);
        }
      });
    });

    updateActiveState();
  }

  updateHandlingPrices(homePickupFee) {
    if (this.homeHandlingPriceEl) {
      this.homeHandlingPriceEl.textContent =
        homePickupFee && Number(homePickupFee) > 0
          ? Shopify.formatMoney(homePickupFee * 100)
          : "Free";
    }

    if (this.dropoffHandlingPriceEl) {
      this.dropoffHandlingPriceEl.textContent = "Free";
    }
  }

  setupConfirmButton() {
    if (!this.confirmBagsButton || this.confirmBagsButton._listenerAttached) return;
    this.confirmBagsButton._listenerAttached = true;
    this.showConfirmBagsButton(false);
    this.confirmBagsButton.addEventListener("click", () => {
      this.hasConfirmedBags = true;
      this.hideConfirmBagsButton();
      this.getFedexRates();
    });
  }

  setupConfirmBagsReconfirm() {
    if (!this.form || this.form._confirmBagsListenerAttached) return;
    this.form._confirmBagsListenerAttached = true;
    const handleBagChange = (event) => {
      if (!this.isBagDetailField(event?.target)) return;
      if (!this.hasConfirmedBags) return;
      this.hasConfirmedBags = false;
      this.showConfirmBagsButton(true);
      this.submitButton?.setAttribute("data-disabled", true);
      this.renderShippingSummaryPlaceholder();
      this.setCardCollapsed(this.outboundCard, true);
      if (this.querySelector("#round_trip")?.checked) {
        this.setCardCollapsed(this.returnCard, true);
      }
    };
    this.form.addEventListener("input", handleBagChange);
    this.form.addEventListener("change", handleBagChange);
  }

  setupStickySummary() {
    if (this._stickySetup) return;
    const sticky = this.querySelector(".smc-right__sticky");
    const rightCol = this.querySelector(".smc-right");
    if (!sticky || !rightCol) return;
    this._stickySetup = true;
    this._stickyHandler = () => this.updateStickySummary(sticky, rightCol);
    window.addEventListener("scroll", this._stickyHandler, { passive: true });
    window.addEventListener("resize", this._stickyHandler);
    this.updateStickySummary(sticky, rightCol);
  }

  getStickyOffset() {
    const rootStyles = getComputedStyle(document.documentElement);
    const headerVar = window.innerWidth >= 990
      ? "--site-header-height-desktop"
      : "--site-header-height-mobile";
    const headerHeight = parseFloat(rootStyles.getPropertyValue(headerVar)) || 0;
    const announcement = document.querySelector(".header-announcement-bar");
    const announcementHeight = announcement ? announcement.getBoundingClientRect().height : 0;
    return headerHeight + announcementHeight + 24;
  }

  updateStickySummary(sticky, rightCol) {
    if (!sticky || !rightCol) return;
    if (window.innerWidth < 990) {
      sticky.style.position = "static";
      sticky.style.top = "";
      sticky.style.left = "";
      sticky.style.width = "";
      sticky.style.bottom = "";
      rightCol.style.minHeight = "";
      return;
    }

    const topOffset = this.getStickyOffset();
    const sectionRect = this.getBoundingClientRect();
    const sectionTop = window.scrollY + sectionRect.top;
    const sectionBottom = sectionTop + this.offsetHeight;
    const stickyHeight = sticky.offsetHeight;
    const maxScroll = sectionBottom - stickyHeight - topOffset;

    rightCol.style.position = "relative";
    rightCol.style.minHeight = `${stickyHeight}px`;

    if (stickyHeight >= this.offsetHeight) {
      sticky.style.position = "static";
      sticky.style.top = "";
      sticky.style.left = "";
      sticky.style.width = "";
      sticky.style.bottom = "";
      return;
    }

    if (window.scrollY < sectionTop - topOffset) {
      sticky.style.position = "static";
      sticky.style.top = "";
      sticky.style.left = "";
      sticky.style.width = "";
      sticky.style.bottom = "";
      return;
    }

    if (window.scrollY <= maxScroll) {
      const rightRect = rightCol.getBoundingClientRect();
      sticky.style.position = "fixed";
      sticky.style.top = `${topOffset}px`;
      sticky.style.left = `${rightRect.left}px`;
      sticky.style.width = `${rightRect.width}px`;
      sticky.style.bottom = "";
      return;
    }

    sticky.style.position = "absolute";
    sticky.style.top = `${sectionBottom - sectionTop - stickyHeight}px`;
    sticky.style.left = "0";
    sticky.style.width = "100%";
    sticky.style.bottom = "";
  }

  isBagDetailField(target) {
    if (!target) return false;
    if (
      target.name?.startsWith("bag_type") ||
      target.name?.startsWith("insurance_value") ||
      target.name === "quantity"
    ) {
      return true;
    }
    return !!target.closest(".insurance-wrapper, .quantity-wrapper, quantity-input");
  }

  showConfirmBagsButton(isReconfirm) {
    if (!this.confirmBagsButton) return;
    this.confirmBagsButton.textContent = isReconfirm
      ? "Re-confirm bags and continue"
      : "Confirm bags and continue";
    this.confirmBagsButton.style.display = "";
  }

  hideConfirmBagsButton() {
    if (!this.confirmBagsButton) return;
    this.confirmBagsButton.style.display = "none";
  }

  getPickupModeKey() {
    const handling =
      this.form.querySelector('input[name="dropoff_strategy"]:checked')?.value ||
      "deliver_to_fedex_warehouse";
    return handling === "home_pickup" ? "home_pickup" : "dropoff";
  }

  setCardCollapsed(card, collapsed) {
    if (!card) return;
    card.classList.toggle("smc-card--collapsed", collapsed);
  }

  setCardLoading(card, isLoading) {
    if (!card) return;
    card.classList.toggle("smc-card--loading", isLoading);
  }

  setOutboundLoading(isLoading) {
    if (this.outboundSpinner) {
      this.outboundSpinner.style.display = isLoading ? "inline-flex" : "none";
    }
  }

  setReturnLoading(isLoading) {
    if (this.returnSpinner) {
      this.returnSpinner.style.display = isLoading ? "inline-flex" : "none";
    }
  }

  setSubmitLoading(isLoading) {
    if (!this.submitButton) return;
  }

  updateServiceDateCaptions() {
    const firstDate = this.form.querySelector("#first_date")?.value || "";
    const lastDate = this.form.querySelector("#last_date")?.value || "";
    const outboundText = firstDate
      ? `All services will deliver on or before ${this.formatDayOfWeek(firstDate)}`
      : "All services will deliver on or before —";
    const returnText = lastDate
      ? `All services will pick up on ${this.formatDayOfWeek(lastDate)}`
      : "All services will pick up on —";
    if (this.outboundDeliverBy) this.outboundDeliverBy.textContent = outboundText;
    if (this.returnCollectionOn) this.returnCollectionOn.textContent = returnText;
    this.toggleReturnCardVisibility();
  }

  toggleReturnCardVisibility() {
    const isRoundTrip = this.querySelector("#round_trip")?.checked;
    if (this.returnCard) {
      this.returnCard.style.display = isRoundTrip ? "" : "none";
    }
  }

  disconnectedCallback() {
    this._observers.forEach((observer) => observer.disconnect());
    this._observers = [];
  }

  closeModal() {
    this.setBodyScrollLock(false);
    // Remove show class
    this.modal.classList.remove("show");
    
    // Clear modal fields
    if (this.inputAddress) this.inputAddress.value = "";
    if (this.inputPostcode) this.inputPostcode.value = "";
    if (this.inputCity) this.inputCity.value = "";
    if (this.inputState) this.inputState.value = "";
    
    // Disable save button
    if (this.saveAddressButton) {
      this.saveAddressButton.setAttribute("disabled", "true");
    }
    
    // Clear the current editing input reference
    this.currentEditingInput = null;
    
    // Clear original values tracking
    this.originalModalValues = null;
    
    // Remove visible class from all autocomplete containers (main form)
    document.querySelectorAll(".autocomplete-container").forEach(container => {
      container.classList.remove("visible");
    });
  }

  showLoading() {
    this.overlay.classList.remove("hidden");
    this.classList.add("loading");
  }

  hideLoading() {
    this.overlay.classList.add("hidden");
    this.classList.remove("loading");
  }

  setupBagTypeModal() {
    const modal = document.querySelector("[data-bag-type-modal]");
    if (!modal || modal.dataset.bagTypeModalInit) return;
    modal.dataset.bagTypeModalInit = "true";

    const dropdown = modal.querySelector("[data-bag-type-dropdown]");
    const dropdownButton = modal.querySelector("[data-bag-type-dropdown-button]");
    const dropdownMenu = modal.querySelector("[data-bag-type-dropdown-menu]");
    const options = Array.from(modal.querySelectorAll("[data-bag-type-option]"));
    const dropdownLabel = modal.querySelector("[data-bag-type-dropdown-label]");
    const dropdownIcon = modal.querySelector("[data-bag-type-dropdown-icon]");
    const contents = Array.from(modal.querySelectorAll("[data-bag-type-content]"));
    const modalBody = modal.querySelector(".modal-body");

    if (!dropdown || !dropdownButton || !dropdownMenu || !options.length) return;

    const updateModalHeight = () => {
      if (!modalBody || !contents.length) return;
      const activeContent = contents.find((content) =>
        content.classList.contains("active"),
      );
      let maxHeight = 0;
      contents.forEach((content) => {
        const wasActive = content.classList.contains("active");
        content.style.display = "block";
        content.style.visibility = "hidden";
        content.style.position = "static";
        const height = content.scrollHeight;
        if (height > maxHeight) maxHeight = height;
        content.style.display = wasActive ? "block" : "";
        content.style.visibility = "";
        content.style.position = "";
        if (!wasActive) {
          content.classList.remove("active");
        }
      });
      if (activeContent) {
        activeContent.classList.add("active");
      }
      if (maxHeight > 0) {
        modalBody.style.minHeight = `${maxHeight}px`;
      }
    };

    const closeDropdown = () => {
      dropdown.classList.remove("is-open");
      dropdownButton.setAttribute("aria-expanded", "false");
    };

    const openDropdown = () => {
      dropdown.classList.add("is-open");
      dropdownButton.setAttribute("aria-expanded", "true");
    };

    const setActive = (value, optionEl) => {
      options.forEach((option) => {
        const isActive = option.dataset.bagTypeValue === value;
        option.classList.toggle("is-active", isActive);
        option.setAttribute("aria-selected", isActive ? "true" : "false");
      });
      contents.forEach((content) => {
        content.classList.toggle(
          "active",
          content.dataset.bagTypeContent === value,
        );
      });
      if (dropdownLabel && optionEl) {
        dropdownLabel.textContent =
          optionEl.querySelector(".bag-type-dropdown__option-label")?.textContent?.trim() ||
          dropdownLabel.textContent;
      }
      if (dropdownIcon && optionEl) {
        const optionIcon = optionEl.querySelector(".bag-type-dropdown__option-icon img");
        if (optionIcon) {
          dropdownIcon.innerHTML = optionIcon.outerHTML;
        } else {
          dropdownIcon.innerHTML = "";
        }
      }
    };

    dropdownButton.addEventListener("click", (event) => {
      event.preventDefault();
      dropdown.classList.contains("is-open") ? closeDropdown() : openDropdown();
    });

    options.forEach((option) => {
      option.addEventListener("click", (event) => {
        event.preventDefault();
        const value = option.dataset.bagTypeValue;
        if (!value) return;
        setActive(value, option);
        updateModalHeight();
        closeDropdown();
      });
    });

    document.addEventListener("click", (event) => {
      if (!dropdown.contains(event.target)) {
        closeDropdown();
      }
    });

    const activeOption = options.find((option) => option.classList.contains("is-active"));
    if (activeOption) {
      setActive(activeOption.dataset.bagTypeValue, activeOption);
    }

    updateModalHeight();
    modal.querySelectorAll("img").forEach((img) => {
      if (img.complete) return;
      img.addEventListener("load", updateModalHeight, { once: true });
    });

    window.addEventListener("resize", updateModalHeight);
  }

  setupEditButtonListener(input) {
    if (!input) return;
    
    const editButton = input.closest(".form-group")?.querySelector("[data-modal-edit]");
    if (!editButton || editButton._listenerAttached) return;
    
    editButton._listenerAttached = true;
    editButton.addEventListener("click", (e) => {
      e.preventDefault();

      // Store which input is being edited
      this.currentEditingInput = input;

      const prefix = input.name === "origin" ? "refulfil:origin" : "refulfil:destination";

      const company = sessionStorage.getItem(`${prefix}:company`);
      const address = sessionStorage.getItem(`${prefix}:address`);
      const address2 = sessionStorage.getItem(`${prefix}:address2`);
      const city = sessionStorage.getItem(`${prefix}:city`);
      const state = sessionStorage.getItem(`${prefix}:state`);
      const postalCode = sessionStorage.getItem(`${prefix}:postal`);

      this.inputCompany.value = company || "";
      this.inputAddress.value = address || "";
      this.inputAddress2.value = address2 || "";
      this.inputPostcode.value = postalCode || "";
      this.inputCity.value = city || "";
      this.inputState.value = state || "";
      
      // Store original values to track changes
      this.originalModalValues = {
        company: company || "",
        address: address || "",
        address2: address2 || "",
        city: city || "",
        state: state || "",
        postalCode: postalCode || ""
      };
      
      // Disable save button initially (no changes yet)
      if (this.saveAddressButton) {
        this.saveAddressButton.setAttribute("disabled", "true");
      }

      this.setBodyScrollLock(true);
      this.modal.classList.add("show");
      setTimeout(() => {
        this.initializeMap(address);
      }, 100);
    });
  }


  setupSaveAddressButton() {
    if (!this.saveAddressButton) return;

    this.saveAddressButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.saveAddressFromModal();
    });

    // Monitor modal input changes to enable/disable save button based on changes
    const requiredModalInputs = [this.inputAddress, this.inputPostcode, this.inputCity, this.inputState];
    const allModalInputs = [this.inputCompany, this.inputAddress, this.inputAddress2, this.inputCity, this.inputState, this.inputPostcode];
    allModalInputs.forEach(input => {
      if (!input) return;
      input.addEventListener("input", () => {
        // Check if all REQUIRED fields are filled (company and address2 are optional)
        const allFilled = requiredModalInputs.every(i => i && i.value && i.value.trim() !== "");
        
        // Check if any values have changed from original (including optional fields)
        const hasChanges = this.originalModalValues && (
          (this.inputCompany?.value || "") !== this.originalModalValues.company ||
          (this.inputAddress?.value || "") !== this.originalModalValues.address ||
          (this.inputAddress2?.value || "") !== this.originalModalValues.address2 ||
          (this.inputCity?.value || "") !== this.originalModalValues.city ||
          (this.inputState?.value || "") !== this.originalModalValues.state ||
          (this.inputPostcode?.value || "") !== this.originalModalValues.postalCode
        );
        
        // Enable button only if all required fields are filled AND there are changes
        if (allFilled && hasChanges) {
          this.saveAddressButton.removeAttribute("disabled");
        } else {
          this.saveAddressButton.setAttribute("disabled", "true");
        }
      });
    });
  }

  debounce(fn, delay = 200) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  /**
   * Single source of truth for whether the autocomplete dropdown should be visible.
   * Both courses and addresses render into .places-results, so we just check that.
   */
  updateDropdownVisibility(inputEl) {
    if (!inputEl) return;
    const formGroup = inputEl.closest(".form-group");
    const container = formGroup?.querySelector(".autocomplete-container");
    const helper = formGroup?.querySelector("#custom-helper");
    if (!container) return;

    const mode = inputEl.dataset.autocompleteMode || "addresses";
    const isFocused = document.activeElement === inputEl;
    const hasQuery = inputEl.value.trim().length >= 2;
    const placesResults = container.querySelector(".places-results");
    const hasResults = placesResults && placesResults.children.length > 0;

    const shouldShow = isFocused && (hasResults || hasQuery);

    if (helper) helper.style.display = (mode !== "courses" && shouldShow) ? "flex" : "none";

    if (shouldShow) {
      container.classList.add("visible");
    } else {
      container.classList.remove("visible");
    }
  }

  setAutocompleteMode(inputEl, mode) {
    if (!inputEl) return;
    inputEl.dataset.autocompleteMode = mode;
    const formGroup = inputEl.closest(".form-group");
    const container = formGroup?.querySelector(".autocomplete-container");
    if (container) container.classList.toggle("mode-courses", mode === "courses");

    // Clear results when switching modes
    const placesResults = formGroup?.querySelector(".places-results");
    if (placesResults) placesResults.innerHTML = "";

    this.updateDropdownVisibility(inputEl);
  }

  setToggleMode(mode, target) {
    if (!target) return;
    const buttons = target.querySelectorAll(".autocomplete-toggle__btn");
    buttons.forEach((btn) => btn.classList.remove("is-active"));
    const active = target.querySelector(`.autocomplete-toggle__btn[data-mode="${mode}"]`);
    if (active) active.classList.add("is-active");
  }

  setupCourseSearchListeners() {
    // Cache for golf course results per input
    this.courseCache = this.courseCache || new Map();
    this._observers = this._observers || [];
    
    const handleInput = (inputEl, isDestination) => {
      if (!inputEl) return;
      const container = inputEl.closest(".form-group")?.querySelector(".autocomplete-container");
      const resultsEl = container?.querySelector(".places-results");
      const helperEl = container?.querySelector("#custom-helper");
      if (!container || !resultsEl) return;
      
      // Get cache key for this input
      const cacheKey = isDestination ? 'destination' : 'origin';
      inputEl._courseCacheKey = cacheKey;

      const fetchCourses = async (query) => {
        if (this.courseSearchAbort) {
          this.courseSearchAbort.abort();
        }
        this.courseSearchAbort = new AbortController();
        const { signal } = this.courseSearchAbort;
        return GetClubsAPI.searchGolfCourses(query, { signal });
      };

      const destinationFlagIcon = `<span class="gc-flag-icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M317.007 108C330.814 108 342.007 119.193 342.007 133V167.549L508.931 251.011L510.731 251.91C535.214 264.149 556.081 274.581 570.601 284.716C585.327 294.994 600.807 309.917 600.807 333C600.807 356.083 585.327 371.006 570.601 381.284C556.081 391.419 535.214 401.85 510.731 414.09L342.007 498.45V666.333C342.007 680.14 330.814 691.333 317.007 691.333C303.201 691.333 292.008 680.14 292.008 666.333V483.54C291.998 483.193 291.998 482.843 292.008 482.497V183.503C291.998 183.155 291.998 182.807 292.008 182.458V133C292.008 119.193 303.201 108 317.007 108Z" fill="#9ca3af"/></svg></span>`;

      const renderResults = (items) => {
        resultsEl.innerHTML = "";
        items.forEach((item) => {
          const row = document.createElement("div");
          row.className = "pac-item";
          row.innerHTML = `${destinationFlagIcon}<div class="pac-item-text"><span class="pac-item-query">${item.name}</span><span class="pac-item-secondary">${item.street_address}, ${item.city}, ${item.state_code} ${item.postal_code}</span></div>`;
          row.addEventListener("click", () => {
            const address = item.street_address || "";
            const city = item.city || "";
            const state = item.state_code || "";
            const postal = item.postal_code || "";
            const courseName = item.name || "";
            const displayAddress = [courseName, address, `${city}, ${state}`, postal].filter(Boolean).join(", ");

            inputEl.value = displayAddress;
            this.markAddressResolved(inputEl);

            // Company / course info - store for both origin and destination
            const prefix = isDestination ? "refulfil:destination" : "refulfil:origin";
            sessionStorage.setItem(`${prefix}:company`, courseName);
            sessionStorage.removeItem(`${prefix}:address2`); // courses don't have apt/suite

            // Store course name for both origin and destination
            sessionStorage.setItem(`${prefix}:course`, courseName);

            // Session storage
            sessionStorage.setItem(`${prefix}:address`, address);
            sessionStorage.setItem(`${prefix}:city`, city);
            sessionStorage.setItem(`${prefix}:state`, state);
            sessionStorage.setItem(`${prefix}:postal`, postal);

            // Derived postal code for later use
            if (isDestination) {
              this.postalCode = postal;
              if (this.hasConfirmedBags) {
                this.debouncedGetFedexRates?.();
              }
            }

            // Update maps using geocoded coordinates for golf course addresses
            this.updateMapLocation(displayAddress);
            this.updateSummaryMapFromStorage();
            this.updateSummaryCard();
            this.updateAddressCallout();

            this.updateDropdownVisibility(inputEl);
          });
          resultsEl.appendChild(row);
        });
      };
      inputEl._renderCourseResults = renderResults;

      const debouncedSearch = this.debounce(async (val, forceRefetch = false) => {
        if (inputEl.dataset.autocompleteMode !== "courses") return;
        if (!val || val.length < 2) {
          resultsEl.innerHTML = "";
          this.updateDropdownVisibility(inputEl);
          return;
        }

        // Check cache first - if query matches cached query for this input, use cached results
        const cached = this.courseCache.get(cacheKey);
        if (!forceRefetch && cached && cached.query === val) {
          renderResults(cached.results);
          this.updateDropdownVisibility(inputEl);
          return;
        }

        try {
          const data = await fetchCourses(val);
          const results = data?.results || [];
          // Cache the results
          this.courseCache.set(cacheKey, { query: val, results: results });
          renderResults(results);
          this.updateDropdownVisibility(inputEl);
          if (results.length === 0) {
            // No golf courses found - auto-switch to addresses mode
            this.setAutocompleteMode(inputEl, "addresses");
            const toggle = isDestination
              ? document.querySelector("[data-autocomplete-toggle-destination]")
              : document.querySelector("[data-autocomplete-toggle-origin]");
            this.setToggleMode("addresses", toggle);
            // Re-trigger the input so Google autocomplete shows address results for the same query
            setTimeout(() => {
              inputEl.dispatchEvent(new Event("input", { bubbles: true }));
            }, 0);
          }
        } catch (e) {
          console.error("Golf course search failed", e);
          this.updateDropdownVisibility(inputEl);
        }
      }, 250);
      inputEl._debouncedCourseSearch = debouncedSearch;

      inputEl.addEventListener("input", (e) => {
        if (inputEl.dataset.autocompleteMode === "courses") {
          debouncedSearch(e.target.value.trim());
        }
      });
    };

    handleInput(this.destinationField, true);
    handleInput(this.originField, false);
  }

  setupAutocompleteToggle() {
    const destinationToggle = document.querySelector("[data-autocomplete-toggle-destination]");
    const originToggle = document.querySelector("[data-autocomplete-toggle-origin]");

    const attachToggle = (wrapper, inputEl) => {
      if (!wrapper || !inputEl) return;
      wrapper.querySelectorAll(".autocomplete-toggle__btn").forEach((btn) => {
        // Prevent focus from leaving the input when clicking the toggle
        btn.addEventListener("mousedown", (e) => {
          e.preventDefault();
        });
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const mode = btn.getAttribute("data-mode");
          if (!mode || inputEl.dataset.autocompleteMode === mode) return;
          this.setAutocompleteMode(inputEl, mode);
          this.setToggleMode(mode, wrapper);

          const query = inputEl.value.trim();
          if (mode === "courses") {
            if (query.length >= 2) {
              const cacheKey = inputEl._courseCacheKey;
              const cached = cacheKey ? this.courseCache?.get(cacheKey) : null;
              if (cached && cached.query === query && typeof inputEl._renderCourseResults === "function") {
                inputEl._renderCourseResults(cached.results);
              } else if (typeof inputEl._debouncedCourseSearch === "function") {
                inputEl._debouncedCourseSearch(query);
              }
            }
          } else {
            // Trigger address search for the current query
            if (query.length >= 2 && typeof inputEl._debouncedAddressSearch === "function") {
              inputEl._debouncedAddressSearch(query);
            }
          }

          // Input stays focused (mousedown preventDefault keeps focus),
          // so just update visibility with the new mode's results
          this.updateDropdownVisibility(inputEl);
        });
      });
    };

    if (destinationToggle) this.setAutocompleteMode(this.destinationField, "courses");
    if (originToggle) this.setAutocompleteMode(this.originField, "courses");
    if (destinationToggle) this.setToggleMode("courses", destinationToggle);
    if (originToggle) this.setToggleMode("courses", originToggle);

    attachToggle(destinationToggle, this.destinationField);
    attachToggle(originToggle, this.originField);
  }

  setBodyScrollLock(lock) {
    const bodyEl = document.body;
    if (!bodyEl) return;
    if (lock) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      bodyEl.style.setProperty('--address-modal-scrollbar-comp', `${scrollbarWidth}px`);
      bodyEl.classList.add('address-modal-open');
    } else {
      bodyEl.classList.remove('address-modal-open');
      bodyEl.style.removeProperty('--address-modal-scrollbar-comp');
    }
  }

  saveAddressFromModal() {
    if (!this.currentEditingInput) return;

    const company = this.inputCompany?.value || "";
    const address = this.inputAddress?.value || "";
    const address2 = this.inputAddress2?.value || "";
    const city = this.inputCity?.value || "";
    const state = this.inputState?.value || "";
    const postal = this.inputPostcode?.value || "";

    // Determine prefix based on which input is being edited
    const prefix = this.currentEditingInput.name === "origin" 
      ? "refulfil:origin" 
      : "refulfil:destination";

    // Save to sessionStorage — remove keys when value is empty to avoid stale data
    // Clear course key if company was changed or emptied (user manually edited a golf course address)
    const storedCourse = sessionStorage.getItem(`${prefix}:course`);
    if (storedCourse && company !== storedCourse) {
      sessionStorage.removeItem(`${prefix}:course`);
    }
    if (company) {
      sessionStorage.setItem(`${prefix}:company`, company);
    } else {
      sessionStorage.removeItem(`${prefix}:company`);
    }
    if (address2) {
      sessionStorage.setItem(`${prefix}:address2`, address2);
    } else {
      sessionStorage.removeItem(`${prefix}:address2`);
    }
    sessionStorage.setItem(`${prefix}:address`, address);
    sessionStorage.setItem(`${prefix}:city`, city);
    sessionStorage.setItem(`${prefix}:state`, state);
    sessionStorage.setItem(`${prefix}:postal`, postal);

    // Destination postal code drives the FedEx rate lookup; keep it in sync.
    // (The address itself is persisted as `_dest_*` cart attributes, not on the line.)
    if (this.currentEditingInput.name === "destination") {
      this.postalCode = postal;
    }

    // Update the main form input with formatted address
    const formattedAddress = [company, address, address2, city, state, postal].filter(Boolean).join(", ");
    this.currentEditingInput.value = formattedAddress;
    this.currentEditingInput.dataset.addressSelected = "true";
    this.markAddressResolved(this.currentEditingInput);
    this.updateSummaryMapFromStorage();
    this.updateSummaryCard();
    this.updateAddressCallout();

    // Show edit button
    const editButton = this.currentEditingInput.closest(".form-group")?.querySelector("[data-modal-edit]");
    if (editButton) {
      editButton.classList.add("show");
    }

    // Close the modal
    this.closeModal();

    // A changed pickup or delivery address changes the rates: re-quote for
    // either field (origin edits used to leave the previous quotes in place).
    if (this.hasConfirmedBags) {
      this.debouncedGetFedexRates();
    }
  }

  async handleOnLoad() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      // The cart's delivery address lives in the order additional details
      // (`_dest_*` cart attributes), persisted on every cart change by
      // persistDestinationToCart (cart-drawer.liquid). When present, hydrate
      // `refulfil:destination:*` sessionStorage from it so the form behaves as if
      // the buyer just picked it, then lock the destination field so the cart
      // keeps a single delivery address.
      const attrs = cart.attributes || {};
      if (attrs._dest_address1) {
        sessionStorage.setItem("refulfil:destination:address", attrs._dest_address1 || "");
        sessionStorage.setItem("refulfil:destination:address2", attrs._dest_address2 || "");
        sessionStorage.setItem("refulfil:destination:city", attrs._dest_city || "");
        sessionStorage.setItem("refulfil:destination:state", attrs._dest_province_code || "");
        sessionStorage.setItem("refulfil:destination:postal", attrs._dest_zip || "");
        sessionStorage.setItem("refulfil:destination:company", attrs._dest_company || "");

        if (attrs._dest_zip) this.postalCode = attrs._dest_zip;

        // Fills + formats the destination field (and shows the edit button) from
        // the sessionStorage we just hydrated.
        this.restoreAddressesFromSession();
        this.destinationField.setAttribute("disabled", true);
      }
    } catch (e) {
    }
  }

  initGoogleAutocomplete(retryCount = 0) {
    const inputs = this.querySelectorAll("[data-modal-opener]");
    const maxRetries = 10;

    if (!window.google || !google.maps || !google.maps.places) {
      if (retryCount < maxRetries) {
        console.warn(
          `Google Maps Places API not loaded yet. Retry ${retryCount + 1}/${maxRetries}`,
        );
        setTimeout(() => this.initGoogleAutocomplete(retryCount + 1), 1500);
      } else {
        console.error(
          "Google Maps Places API failed to load after maximum retries",
        );
      }
      return;
    }

    inputs.forEach((input) => {
      const container = input
        .closest(".form-group")
        .querySelector(".autocomplete-container");

      this.setupAutocomplete(input, container);
    });
  }

  setupAutocomplete(input, container) {
    if (input._autocompleteSetup) return;
    input._autocompleteSetup = true;

    // Ensure mode is set so address search guards work for all inputs (origin has no toggle)
    if (!input.dataset.autocompleteMode) {
      input.dataset.autocompleteMode = "addresses";
    }

    const helper = input.closest(".form-group").querySelector("#custom-helper");
    const resultsEl = container.querySelector(".places-results");

    // Use AutocompleteService for predictions only - we render results ourselves
    let autocompleteService;
    let placesService;
    try {
      autocompleteService = new google.maps.places.AutocompleteService();
      placesService = new google.maps.places.PlacesService(document.createElement("div"));
      input._autocompleteInstance = autocompleteService;
      // Shared handles for resolveTypedAddress() — the same services a
      // suggestion click uses, so typed/pasted text resolves identically.
      this.autocompleteService = autocompleteService;
      this.placesService = placesService;
    } catch (error) {
      console.error("Failed to initialize Google AutocompleteService:", error);
      input._autocompleteSetup = false;
      return;
    }

    const addressIcon = `<span class="gc-flag-icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1C5.24 1 3 3.24 3 6c0 3.75 5 9 5 9s5-5.25 5-9c0-2.76-2.24-5-5-5zm0 6.75c-.97 0-1.75-.78-1.75-1.75S7.03 4.25 8 4.25 9.75 5.03 9.75 6 8.97 7.75 8 7.75z" fill="#9ca3af"/></svg></span>`;

    const renderAddressResults = (predictions) => {
      resultsEl.innerHTML = "";
      predictions.forEach((prediction) => {
        const row = document.createElement("div");
        row.className = "pac-item";
        const main = prediction.structured_formatting?.main_text || prediction.description;
        const secondary = prediction.structured_formatting?.secondary_text || "";
        row.innerHTML = `${addressIcon}<div class="pac-item-text"><span class="pac-item-query">${main}</span><span class="pac-item-secondary">${secondary}</span></div>`;
        row.addEventListener("click", () => {
          this.selectAddressPrediction(prediction, input, placesService);
        });
        resultsEl.appendChild(row);
      });
    };

    const debouncedAddressSearch = this.debounce((query) => {
      if (input.dataset.autocompleteMode !== "addresses") return;
      if (!query || query.length < 2) {
        resultsEl.innerHTML = "";
        this.updateDropdownVisibility(input);
        return;
      }
      autocompleteService.getPlacePredictions(
        {
          input: query,
          componentRestrictions: { country: "us" },
          types: ["street_address", "premise", "lodging"],
        },
        (predictions, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
            resultsEl.innerHTML = "";
            this.updateDropdownVisibility(input);
            return;
          }
          renderAddressResults(predictions);
          this.updateDropdownVisibility(input);
        }
      );
    }, 250);

    // Store reference so toggle handler can trigger address search on mode switch
    input._debouncedAddressSearch = debouncedAddressSearch;

    input.addEventListener("input", (e) => {
      if (input.dataset.autocompleteMode !== "courses") {
        debouncedAddressSearch(e.target.value.trim());
      }
      this.updateDropdownVisibility(input);
    });

    // On focus, re-trigger search for current value
    input.addEventListener("focus", () => {
      if (input.value && input.value.trim().length >= 2) {
        if (input.dataset.autocompleteMode === "courses") {
          if (typeof input._debouncedCourseSearch === "function") {
            input._debouncedCourseSearch(input.value.trim());
          }
        } else {
          debouncedAddressSearch(input.value.trim());
        }
      }
    });
  }

  /**
   * Process a selected Google Places prediction: fetch details and update form
   * state. The details → structured-address step is shared with
   * resolveTypedAddress() so a click and a typed/pasted address resolve the
   * same way.
   */
  selectAddressPrediction(prediction, input, placesService) {
    // An explicit pick supersedes any automatic resolution still in flight
    // for text the customer typed before clicking.
    input._resolveGen = (input._resolveGen || 0) + 1;
    if (placesService && !this.placesService) this.placesService = placesService;

    this.fetchPlaceDetails(prediction?.place_id).then((place) => {
      const parsed = place ? this.parsePlaceComponents(place) : null;
      if (!parsed) {
        console.warn("Place details unavailable for:", prediction?.description || input.value);
        this.showAddressFieldError(
          input,
          `We couldn't confirm this ${input.name === "origin" ? "pickup" : "delivery"} address. Please pick another suggestion.`,
        );
        return;
      }
      this.applyResolvedAddress(input, place, parsed);
    });
  }

  /**
   * Fetch Place Details for a prediction. Resolves null on any failure so
   * callers can fall back to an inline prompt instead of throwing mid-flow.
   */
  fetchPlaceDetails(placeId) {
    return new Promise((resolve) => {
      if (!placeId || !this.placesService || !window.google?.maps?.places) {
        resolve(null);
        return;
      }
      try {
        this.placesService.getDetails(
          { placeId, fields: ["formatted_address", "geometry", "name", "address_component", "type"] },
          (place, status) => {
            if (status !== google.maps.places.PlacesServiceStatus.OK || !place || !place.geometry) {
              console.warn("Place details failed:", status);
              resolve(null);
              return;
            }
            resolve(place);
          },
        );
      } catch (e) {
        console.warn("Place details threw:", e);
        resolve(null);
      }
    });
  }

  /**
   * Split a Place Details result into the structured address the backend and
   * FedEx need. Returns null when Google sent no address components — the
   * caller must then prompt rather than keep the previous structured address.
   */
  parsePlaceComponents(place) {
    if (!place?.address_components) return null;
    const getComp = (type) => {
      const comp = place.address_components.find((c) => c.types.includes(type));
      return comp ? comp.long_name : "";
    };
    const getShortComp = (type) => {
      const comp = place.address_components.find((c) => c.types.includes(type));
      return comp ? comp.short_name : "";
    };

    const streetNumber = getComp("street_number");
    const route = getComp("route");
    const subpremise = getComp("subpremise");
    const locality = getComp("locality");
    const city = locality || getComp("administrative_area_level_2");
    const stateShort = getShortComp("administrative_area_level_1");
    const postal = getComp("postal_code");

    const placeTypes = place.types || [];
    const isEstablishment = placeTypes.some((t) =>
      t === "establishment" || t === "lodging" || t === "point_of_interest"
    );
    const placeName = (place.name || "").trim();

    return {
      company: isEstablishment && placeName ? placeName : "",
      address: [streetNumber, route].filter(Boolean).join(" "),
      address2: subpremise || "",
      city,
      stateCode: stateShort,
      postalCode: postal,
    };
  }

  /**
   * Commit a resolved place to the field, sessionStorage and the summary UI,
   * then re-quote — the single write path for suggestion clicks and
   * automatic resolution, so the visible text and the structured address can
   * never disagree after it runs.
   */
  applyResolvedAddress(input, place, parsed) {
    const prefix = input.name === "origin" ? "refulfil:origin" : "refulfil:destination";

    input.value = place.formatted_address || place.name || input.value;
    this.markAddressResolved(input);

    if (input.name === "destination") {
      this.postalCode = parsed.postalCode;
    }

    if (parsed.company) {
      sessionStorage.setItem(`${prefix}:company`, parsed.company);
    } else {
      sessionStorage.removeItem(`${prefix}:company`);
    }
    if (parsed.address2) {
      sessionStorage.setItem(`${prefix}:address2`, parsed.address2);
    } else {
      sessionStorage.removeItem(`${prefix}:address2`);
    }
    sessionStorage.removeItem(`${prefix}:course`);
    sessionStorage.setItem(`${prefix}:address`, parsed.address);
    sessionStorage.setItem(`${prefix}:city`, parsed.city);
    sessionStorage.setItem(`${prefix}:state`, parsed.stateCode);
    sessionStorage.setItem(`${prefix}:postal`, parsed.postalCode);

    // Hide dropdown after selection
    const resultsEl = input.closest(".form-group")?.querySelector(".places-results");
    if (resultsEl) resultsEl.innerHTML = "";
    this.updateDropdownVisibility(input);

    // Show edit button
    const currentEditEl = input.closest(".form-group")?.querySelector("[data-modal-edit]");
    if (currentEditEl && input.value.trim() !== "") {
      currentEditEl.classList.add("show");
    }
    this.setupEditButtonListener(input);

    this.updateSummaryMapFromStorage();
    this.updateSummaryCard();
    this.updateAddressCallout();

    // A changed address changes the rates. A suggestion click used to rely on
    // the keystroke-driven quote (fetched against the PREVIOUS structured
    // address) — re-quote explicitly, like a course pick does.
    if (this.hasConfirmedBags) {
      this.debouncedGetFedexRates?.();
    }
  }

  initializeMap(address) {
    // The modal is moved to <body> in connectedCallback, so look for the map
    // inside the modal first, falling back to the current element.
    const mapContainer =
      this.modal?.querySelector("#address-map") ||
      document.getElementById("address-map") ||
      this.querySelector("#address-map");
    if (!mapContainer) return;

    // Default location (center of US)
    const defaultLocation = { lat: 39.8283, lng: -98.5795 };

    this.map = new google.maps.Map(mapContainer, {
      zoom: 4,
      center: defaultLocation,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    let map = this.map;
    this.marker = new google.maps.Marker({
      map: map,
      draggable: false,
      visible: false,
    });

    this.geocoder = new google.maps.Geocoder();

    this.updateMapLocation(address);
  }

  updateMapLocation(address) {
    if (!this.geocoder || !address || !this.map || !this.marker) return;

    this.geocoder.geocode(
      {
        address: address,
        componentRestrictions: { country: "US" },
      },
      (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          this.map.setCenter(location);
          this.map.setZoom(15);
          this.marker.setPosition(location);
          this.marker.setVisible(true);
        } else {
          // If geocoding fails, hide the marker but keep the map
          if (this.marker) {
            this.marker.setVisible(false);
          }
        }
      },
    );
  }

  initSummaryMapWhenReady(retryCount = 0) {
    if (!this.summaryMapEl) return;
    const maxRetries = 10;
    if (!window.google || !google.maps) {
      if (retryCount < maxRetries) {
        setTimeout(() => this.initSummaryMapWhenReady(retryCount + 1), 1000);
      }
      return;
    }
    if (this.summaryMapEl.offsetWidth === 0 || this.summaryMapEl.offsetHeight === 0) {
      const layout = this.summaryMapEl.closest(".smc-layout");
      const rightCol = this.summaryMapEl.closest(".smc-right");
      if (retryCount < maxRetries) {
        setTimeout(() => this.initSummaryMapWhenReady(retryCount + 1), 500);
      }
      return;
    }
    if (this.summaryMap) return;

    const usBounds = new google.maps.LatLngBounds(
      { lat: 26.5, lng: -124.0 },
      { lat: 48.0, lng: -67.5 },
    );

    this.summaryMap = new google.maps.Map(this.summaryMapEl, {
      mapTypeId: "roadmap",
      disableDefaultUI: true,
      clickableIcons: false,
      gestureHandling: "none",
      keyboardShortcuts: false,
      restriction: {
        latLngBounds: usBounds,
        strictBounds: false,
      },
      styles: [
        { elementType: "geometry", stylers: [{ color: "#f2f2f2" }] },
        { featureType: "water", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
        { featureType: "water", elementType: "labels", stylers: [{ visibility: "off" }] },
        { elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "poi", stylers: [{ visibility: "off" }] },
        { featureType: "transit", stylers: [{ visibility: "off" }] },
        { featureType: "road", elementType: "geometry", stylers: [{ color: "#f2f2f2" }] },
        { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#e0e0e0" }] },
        { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
      ],
    });

    const pinSize = 24;
    const svgToDataUrl = (svg) =>
      `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
    const makeSvgIcon = (svg) => ({
      url: svgToDataUrl(svg),
      scaledSize: new google.maps.Size(pinSize, pinSize),
      anchor: new google.maps.Point(pinSize / 2, pinSize / 2),
    });
    const originIconSvg = `<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="200" rx="100" fill="#0070F3"/><path d="M59.796 89.0053C58.0214 90.5252 57 92.7449 57 95.0814V138C57 142.418 60.5817 146 65 146H79.3571C83.7754 146 87.3571 142.418 87.3571 138V121.733C87.3571 115.032 92.7937 109.6 99.5 109.6C106.206 109.6 111.643 115.032 111.643 121.733V138C111.643 142.418 115.225 146 119.643 146H134C138.418 146 142 142.418 142 138V95.0814C142 92.7449 140.979 90.5252 139.204 89.0053L104.704 59.4571C101.709 56.8918 97.2912 56.8918 94.296 59.4571L59.796 89.0053Z" fill="white"/></svg>`;
    const destinationIconSvg = `<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="200" rx="100" fill="#0070F3"/><path d="M88.373 49C90.7873 49 92.7446 50.9764 92.7446 53.4143V59.5147L121.934 74.2516L122.249 74.4105C126.53 76.5715 130.179 78.4134 132.718 80.2031C135.293 82.0178 138 84.6527 138 88.7286C138 92.8044 135.293 95.4393 132.718 97.2541C130.179 99.0437 126.53 100.886 122.249 103.047L92.7446 117.942V147.586C92.7446 150.024 90.7873 152 88.373 152C85.9586 152 84.0013 150.024 84.0013 147.586V115.31C83.9996 115.248 83.9996 115.187 84.0013 115.125V62.3317C83.9996 62.2703 83.9996 62.2088 84.0013 62.1472V53.4143C84.0013 50.9764 85.9586 49 88.373 49Z" fill="white"/></svg>`;

    this.summaryOriginMarker = new google.maps.Marker({
      map: this.summaryMap,
      icon: makeSvgIcon(originIconSvg),
      visible: false,
    });

    this.summaryDestinationMarker = new google.maps.Marker({
      map: this.summaryMap,
      icon: makeSvgIcon(destinationIconSvg),
      visible: false,
    });

    this.summaryPolyline = new google.maps.Polyline({
      geodesic: true,
      strokeColor: "#0ea5e9",
      strokeOpacity: 1.0,
      strokeWeight: 3,
      map: this.summaryMap,
    });

    const applyUsBounds = () => {
      this.summaryMap.fitBounds(usBounds);
    };
    this.summaryBounds = usBounds;
    applyUsBounds();
    this.summaryGeocoder = new google.maps.Geocoder();
    this.updateSummaryMapFromStorage();

    google.maps.event.addDomListener(window, "resize", () => {
      applyUsBounds();
    });
  }

  updateSummaryMapFromStorage() {
    const origin = [
      sessionStorage.getItem("refulfil:origin:address"),
      sessionStorage.getItem("refulfil:origin:city"),
      sessionStorage.getItem("refulfil:origin:state"),
      sessionStorage.getItem("refulfil:origin:postal"),
    ]
      .filter(Boolean)
      .join(", ");
    const destination = [
      sessionStorage.getItem("refulfil:destination:address"),
      sessionStorage.getItem("refulfil:destination:city"),
      sessionStorage.getItem("refulfil:destination:state"),
      sessionStorage.getItem("refulfil:destination:postal"),
    ]
      .filter(Boolean)
      .join(", ");
    this.updateSummaryMap(origin, destination);
  }

  updateSummaryMap(originAddress, destinationAddress) {
    if (!this.summaryGeocoder || !this.summaryMap) return;
    const updateMarker = (address, marker, cb) => {
      if (!address) {
        marker.setVisible(false);
        cb(null);
        return;
      }
      this.summaryGeocoder.geocode(
        { address, componentRestrictions: { country: "US" } },
        (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
            marker.setPosition(location);
            marker.setVisible(true);
            cb(location);
          } else {
            marker.setVisible(false);
            cb(null);
          }
        },
      );
    };

    updateMarker(originAddress, this.summaryOriginMarker, (originLocation) => {
      updateMarker(destinationAddress, this.summaryDestinationMarker, (destinationLocation) => {
        if (originLocation && destinationLocation) {
          this.summaryPolyline.setPath([originLocation, destinationLocation]);
        } else {
          this.summaryPolyline.setPath([]);
        }
        if (this.summaryBounds) {
          this.summaryMap.fitBounds(this.summaryBounds);
        }
      });
    });
  }

  initDatePickers() {
    const dateInputs = this.querySelectorAll("[data-date-picker]");
    dateInputs.forEach((dateInput) => this.setupDatePicker(dateInput));
  }

  setupDatePicker() {
    const deliveryDiv = this.querySelector("#delivery_date_display");
    const returnDiv = this.querySelector("#return_date_display");
    const firstDateInput = this.querySelector("#first_date");
    const lastDateInput = this.querySelector("#last_date");
    const roundTripCheckbox = this.querySelector("#round_trip");
    const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

    // Use the minimum date fetched from the API, or fallback to tomorrow
    const minDate = this.minimumDate || new Date().fp_incr(1);
    const readStoredDates = () => ({
      start: sessionStorage.getItem("refulfil:dates:start"),
      end: sessionStorage.getItem("refulfil:dates:end"),
    });
    const toStoredDate = (value) => {
      if (!value) return null;
      const date = new Date(value);
      return isNaN(date) ? null : date;
    };

    let fp = flatpickr(deliveryDiv, {
      dateFormat: "Y-m-d",
      minDate: minDate,
      locale: {
        firstDayOfWeek: 1,
      },
      onDayCreate: (_dObj, _dStr, _fp, dayElem) => {
        if (!dayElem?.dateObj || !isWeekend(dayElem.dateObj)) return;
        dayElem.classList.add("flatpickr-disabled", "smc-weekend-disabled");
        dayElem.setAttribute("aria-disabled", "true");
        dayElem.setAttribute("data-weekend-disabled", "true");
        dayElem.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
        });
      },
      clickOpens: true,
      allowInput: false,
      disableMobile: true,
      mode: roundTripCheckbox.checked ? "range" : "single",
      onChange: (selectedDates) => {
        if (roundTripCheckbox.dataset.modeSwitching === "true") {
          return;
        }
        if (roundTripCheckbox.checked && selectedDates.length === 2) {
          const [start, end] = selectedDates;
          firstDateInput.value = fp.formatDate(start, "Y-m-d");
          lastDateInput.value = fp.formatDate(end, "Y-m-d");
          sessionStorage.setItem("refulfil:dates:start", fp.formatDate(start, "m/d/Y"));
          sessionStorage.setItem("refulfil:dates:end", fp.formatDate(end, "m/d/Y"));

          deliveryDiv.querySelector(".value").textContent = fp.formatDate(
            start,
            "M j Y",
          );
          returnDiv.querySelector(".value").textContent = fp.formatDate(
            end,
            "M j Y",
          );
          returnDiv.classList.remove("disabled");
          this.updateServiceDateCaptions();
          this.updateSummaryCard();
          if (this.hasConfirmedBags) {
            this.debouncedGetFedexRates?.();
          }
        } else if (!roundTripCheckbox.checked && selectedDates.length === 1) {
          const [start] = selectedDates;
          firstDateInput.value = fp.formatDate(start, "Y-m-d");
          lastDateInput.value = "";
          sessionStorage.setItem("refulfil:dates:start", fp.formatDate(start, "m/d/Y"));
          sessionStorage.removeItem("refulfil:dates:end");

          deliveryDiv.querySelector(".value").textContent = fp.formatDate(
            start,
            "M j Y",
          );
          returnDiv.querySelector(".value").textContent =
            "Choose 1 day after play";
          returnDiv.classList.add("disabled");
          this.updateServiceDateCaptions();
          this.updateSummaryCard();
          if (this.hasConfirmedBags) {
            this.debouncedGetFedexRates?.();
          }
        }
      },
    });

    // Ensure return date UI matches default checkbox state on load
    returnDiv.classList.toggle("disabled", !roundTripCheckbox.checked);

    const { start: storedStart, end: storedEnd } = readStoredDates();
    if (storedStart) {
      const startDate = toStoredDate(storedStart);
      const endDate = toStoredDate(storedEnd);
      if (startDate) {
        if (roundTripCheckbox.checked && endDate) {
          fp.setDate([startDate, endDate], true);
        } else {
          fp.setDate(startDate, true);
        }
      }
    }

    roundTripCheckbox.addEventListener("change", () => {
      roundTripCheckbox.dataset.modeSwitching = "true";
      const existingDates = fp.selectedDates ? [...fp.selectedDates] : [];
      const existingFirstDate = existingDates[0] || null;

      fp.set("mode", roundTripCheckbox.checked ? "range" : "single");
      returnDiv.classList.toggle("disabled", !roundTripCheckbox.checked);

      if (roundTripCheckbox.checked) {
        // Switching to round trip: clear and prompt for range
        firstDateInput.value = "";
        lastDateInput.value = "";
        deliveryDiv.querySelector(".value").textContent = "Select a date";
        returnDiv.querySelector(".value").textContent = "Choose 1 day after play";
        if (!this.hasSelectedServices()) {
          this.renderShippingSummaryPlaceholder();
        }
        fp.clear();
        const storedDates = readStoredDates();
        const startDate = toStoredDate(storedDates.start);
        const endDate = toStoredDate(storedDates.end);
        if (startDate && endDate) {
          fp.setDate([startDate, endDate], false);
          firstDateInput.value = fp.formatDate(startDate, "Y-m-d");
          lastDateInput.value = fp.formatDate(endDate, "Y-m-d");
            deliveryDiv.querySelector(".value").textContent = fp.formatDate(
              startDate,
              "M j Y",
            );
            returnDiv.querySelector(".value").textContent = fp.formatDate(
              endDate,
              "M j Y",
            );
          returnDiv.classList.remove("disabled");
        }
        this.updateServiceDateCaptions();
        roundTripCheckbox.dataset.modeSwitching = "false";
        return;
      }

      // Switching to one-way: keep the original delivery date if available
      const fallbackDate =
        existingFirstDate ||
        (firstDateInput.value ? new Date(firstDateInput.value.replace(/-/g, "/")) : null);

      fp.clear();

      if (fallbackDate && !isNaN(fallbackDate)) {
        fp.setDate(fallbackDate, true);
        firstDateInput.value = fp.formatDate(fallbackDate, "Y-m-d");
        lastDateInput.value = "";
        deliveryDiv.querySelector(".value").textContent = fp.formatDate(
          fallbackDate,
          "M j Y",
        );
      } else {
        firstDateInput.value = "";
        lastDateInput.value = "";
        deliveryDiv.querySelector(".value").textContent = "Select a date";
      }

      returnDiv.querySelector(".value").textContent = "Choose 1 day after play";

      if (!this.hasSelectedServices()) {
        this.renderShippingSummaryPlaceholder();
      }
      this.updateServiceDateCaptions();
      roundTripCheckbox.dataset.modeSwitching = "false";
    });

    returnDiv.addEventListener("click", (e) => {
      if (returnDiv.classList.contains("disabled")) {
        return;
      }

      deliveryDiv.click();
    });
  }

  allFieldsCompleted(event) {
    if (!this.form) return false;

    const fields = this.form.querySelectorAll("input, select");

    if (event?.target?.id === "round_trip" || event?.target?.name === "round_trip") {
      this.toggleReturnCardVisibility();
      this.renderReturnOptions(true);
      this.updatePricingAndSummary();
      this.updateServiceDateCaptions();
      return true;
    }

    if (event?.target?.name === "dropoff_strategy") {
      if (this.shippingData) {
        this.updatePricingAndSummary();
      }
      return true;
    }

    if (
      event?.target?.name === "outbound_service_option" ||
      event?.target?.name === "return_service_option"
    ) {
      if (this.shippingData) {
        this.updatePricingAndSummary();
      }
      return true;
    }

    if (
      event?.target?.id &&
      (event.target.id === "first_date" ||
        event.target.id === "last_date" ||
        event.target.id === "delivery_date_display") &&
      this.querySelector("#round_trip")?.dataset?.modeSwitching === "true"
    ) {
      return true;
    }

    if (this.skipNextRateCall) {
      this.skipNextRateCall = false;
      return false; // prevent follow-up rate call on this change
    }

    if (this.isBagDetailField(event?.target)) {
      return true;
    }

    for (const field of fields) {
      if (field.name === "insurance_value") {
        if (!field.value || field.value.trim() === "") {
          const firstOption = field.querySelector("option");
          if (!firstOption) {
            return false;
          }
          field.value = firstOption.value;
          field.dispatchEvent(new Event("input", { bubbles: true }));
          field.dispatchEvent(new Event("change", { bubbles: true }));
        }
        continue;
      }

      if (field.closest(".address-picker__modal-content")) {
        continue;
      }
      if (field.disabled || field.type === "hidden") continue;

      if (!field.value || field.value.trim() === "") {
        return false;
      }
    }
    if (this.skipNextRateCall) {
      this.skipNextRateCall = false;
      return true;
    }
    if (!this.hasConfirmedBags) {
      return true;
    }
    this.debouncedGetFedexRates();
    return true;
  }

  async handleFormSubmit() {
    // Prevent submission if button is disabled
    if (this.submitButton.getAttribute("data-disabled") === "true") {
      return;
    }

    // Never add a line for an address the customer typed but never resolved,
    // and never against quotes fetched for different addresses/dates/bags than
    // the ones on screen — the cart line carries the quote ids that decide
    // where FedEx labels ship from and to.
    const unresolvedField = await this.ensureAddressesResolved();
    if (unresolvedField) {
      unresolvedField.dataset.skipClearOnFocus = "true";
      unresolvedField.focus();
      return;
    }
    if (this.isQuoteStale()) {
      this.skipNextRateCall = false;
      await this.getFedexRates();
      if (this.isQuoteStale()) {
        this.showQuoteRefreshError();
        return;
      }
    }

    // Never add a line item whose structured origin/destination is incomplete:
    // the cart-transform quote would have a blank address and fail at label
    // generation. Prompt for a fresh address selection instead.
    const invalidField = this.validateStructuredAddresses();
    if (invalidField) {
      invalidField.focus();
      return;
    }

    const variantId = this.querySelector(".product-variant-id").value;
    const firstDay = this.querySelector("#first_date").value;
    const lastDay = this.querySelector("#last_date").value;
    const totalBags = this.querySelectorAll("[data-insurance]").length || 1;
    const originAddress = this.querySelector('[name="origin"]').value;
    const destinationAddress = this.querySelector('[name="destination"]').value;

    // Convert dates from YYYY-MM-DD to MM/DD/YYYY format
    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const [year, month, day] = dateStr.split('-');
      return `${month}/${day}/${year}`;
    };

    const formattedFirstDay = formatDate(firstDay);
    const formattedLastDay = formatDate(lastDay);

    // No need to store full concatenated addresses anymore
    // Individual components are already stored in sessionStorage via saveAddressFromModal()
    
    const formData = new FormData(this.form);

    formData.set("id", variantId);
    // Ship my clubs service products should always have quantity of 1
    // The number of bags only affects the "Total bags" property
    formData.set("quantity", 1);

    formData.append("properties[Total bags]", totalBags);
    formData.append("properties[Delivery by]", formattedFirstDay);
    formData.append("properties[Return collection on]", formattedLastDay);
    formData.append("properties[Origin]", originAddress);
    formData.append("properties[Destination]", destinationAddress);

    // The delivery address is no longer written to the cart line — it is persisted
    // to the order as `_dest_*` cart attributes by the cartUpdate subscriber in
    // cart-drawer.liquid (which fires on the publish after this add).

    // _shipping_price should carry the quote ID (not the dollar amount)
    const shippingPriceField = this.form.querySelector('[name="properties[_shipping_price]"]');
    const quoteIdValue = this.selectedServiceId || this.shippingPriceInput?.value || "";
    if (shippingPriceField) {
      shippingPriceField.value = quoteIdValue;
    }
    formData.set("properties[_shipping_price]", quoteIdValue);

    // _smc_price carries an array of API-signed { quoteId, price, signature, expiry }
    // entries: the customer's selected quote first, then alternative outbound
    // services that ship LATER (i.e. more expensive but still meet the same
    // arrival date) for the same return service and pickup type. The cart
    // transform applies the first signature-valid entry; the storefront
    // cleanup script (smc-cart-cleanup.js) prunes entries past their expiry,
    // and falls back to the next when the originally-selected one expires.
    const smcPriceField = this.form.querySelector('[name="properties[_smc_price]"]');
    const smcPriceEntries = this.buildSmcPriceEntries(quoteIdValue);
    if (smcPriceEntries.length > 0) {
      const smcPriceValue = JSON.stringify(smcPriceEntries);
      if (smcPriceField) {
        smcPriceField.value = smcPriceValue;
      }
      formData.set("properties[_smc_price]", smcPriceValue);
    }
    
    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id),
      );
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = formData;

    try {
      const res = await fetch(`${routes.cart_add_url}.js`, config);

      if (!res.ok) throw new Error(`Cart API error: ${res.status}`);

      const data = await res.json();

      // The delivery address is persisted to the order additional details
      // (`_dest_*` cart attributes) by the global cartUpdate subscriber in
      // cart-drawer.liquid, which fires on the publish below.

      // Publish cart update event
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "custom-product-form",
          productVariantId: variantId,
          cartData: data,
        });
      }
      
      // Render cart contents (opens drawer and updates counter)
      if (this.cart) {
        this.cart.renderContents(data);
      }
      
      // Dispatch event to update T&C modal checkboxes
      document.dispatchEvent(new CustomEvent("refulfil:confirmationModal"));
    } catch (err) {
      console.error("Failed to add to cart:", err);
    } finally {
      if (this.cart && this.cart.classList.contains("is-empty"))
        this.cart.classList.remove("is-empty");
    }
  }

  async getFedexRates() {
    if (this.skipNextRateCall) {
      this.skipNextRateCall = false;
      this.querySelector(".pdp-rates__summary").classList.remove("loading");
      this.setOutboundLoading(false);
      return;
    }
    if (this.querySelector("#first_date").value === "") {
      return;
    }
    if (!this.form) return;
    if (!this.hasConfirmedBags) return;
    // Never quote while an address box holds text that has not been resolved
    // into a structured address: the quote would silently use the PREVIOUS
    // address. Mid-typing text is left alone (blur resolves it and re-quotes);
    // text sitting in an unfocused field (e.g. restored on load) is resolved now.
    const unresolvedField = [this.originField, this.destinationField].find((f) =>
      this.isAddressFieldUnresolved(f),
    );
    if (unresolvedField) {
      if (document.activeElement !== unresolvedField && !unresolvedField._resolution) {
        this.resolveTypedAddress(unresolvedField);
      }
      return;
    }
    this.submitButton.setAttribute("data-disabled", true);
    if (this.postalCode == null) {
      this.postalCode = sessionStorage.getItem("refulfil:destination:postal");
    }
    this.querySelector(".pdp-rates__summary").classList.add("loading");
    this.setOutboundLoading(true);
    this.setReturnLoading(true);
    this.setSubmitLoading(true);
    this.setCardLoading(this.outboundCard, true);
    this.setCardLoading(this.returnCard, true);
    this.setCardCollapsed(this.outboundCard, true);
    if (this.querySelector("#round_trip")?.checked) {
      this.setCardCollapsed(this.returnCard, true);
    }
    const formData = new FormData(this.form);
    const values = Object.fromEntries(formData.entries());

    const bag_items = this.collectBagItems(values);

    const finalData = {
      bag_items,
    };

    const totalInsurance = bag_items.reduce(
      (sum, item) => sum + Number(item.insurance_value || 0),
      0,
    );

    this.querySelector("[data-total-insurance-value]").value =
      Shopify.formatMoney(totalInsurance * 100);
    
    // Format addresses for backend
    finalData.originAddress = this.getStoredOrigin();
    finalData.destinationAddress = this.getStoredDestination();
    finalData.first_date = values["first_date"];
    const isRoundTrip = this.querySelector("#round_trip")?.checked;
    finalData.round_trip = !!isRoundTrip;
    if (isRoundTrip && values["last_date"]) {
      finalData.last_date = values["last_date"];
    }
    finalData.variant = document.querySelector(".product-variant-id").value;
    finalData.postalCode = this.postalCode;
    finalData.origin = this.originField?.value || "";
    finalData.destination = this.destinationField?.value || "";

    // Guard: the structured origin/destination (sessionStorage) can be empty
    // even when the visible field shows text. Sending a blank originAddress
    // produces a quote that can never generate a FedEx label, so abort here
    // and prompt the customer to re-select the address from the suggestions.
    const invalidField = this.validateStructuredAddresses();
    if (invalidField) {
      this.querySelector(".pdp-rates__summary").classList.remove("loading");
      this.setOutboundLoading(false);
      this.setReturnLoading(false);
      this.setSubmitLoading(false);
      this.setCardLoading(this.outboundCard, false);
      this.setCardLoading(this.returnCard, false);
      this.submitButton.setAttribute("data-disabled", true);
      // Don't steal focus here — getFedexRates fires reactively while the user
      // may still be editing. The inline error is enough; the add-to-cart guard
      // focuses the field on an explicit submit.
      return;
    }

    const fingerprint = this.quoteFingerprint();

    try {
      const data = await GetClubsAPI.getSmcShippingRates(finalData);
      this.shippingData = data;
      this.shippingDataFingerprint = fingerprint;
      this.clearQuoteRefreshError();
      this.renderOutboundOptions(true);
      this.renderReturnOptions(true);
      this.updatePricingAndSummary();
      this.updateServiceDateCaptions();
    } catch (e) {
      console.error("Fetch error:", e);
    } finally {
      this.querySelector(".pdp-rates__summary").classList.remove("loading");
      this.setOutboundLoading(false);
      this.setReturnLoading(false);
      this.setSubmitLoading(false);
      this.setCardLoading(this.outboundCard, false);
      this.setCardLoading(this.returnCard, false);
    }
  }

  formatMoneyFromNumber(amount) {
    return Shopify.formatMoney(Math.round(amount * 100));
  }

  formatFriendlyDate(dateStr) {
    if (!dateStr) return "";
    const d = new Date(dateStr + "T00:00:00");
    if (isNaN(d)) return dateStr;
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  }

  formatDayOfWeek(dateStr) {
    if (!dateStr) return "";
    const d = new Date(dateStr + "T00:00:00");
    if (isNaN(d)) return dateStr;
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return `${days[d.getDay()]} ${this.formatFriendlyDate(dateStr)}`;
  }

  getOutboundIcon(serviceType) {
    if (serviceType === "FEDEX_GROUND") return this.iconGround;
    if (serviceType === "FEDEX_2_DAY") return this.icon2Day;
    return this.iconExpress;
  }

  getServiceIcon(serviceType) {
    let icon = "";
    if (serviceType === "FEDEX_GROUND") icon = this.iconGround16;
    else if (serviceType === "FEDEX_2_DAY") icon = this.icon2Day16;
    else icon = this.iconExpress16;
    return icon
      .replace('handling-option__icon', 'smc-service-icon')
      .replace('width="16"', 'width="24"')
      .replace('height="16"', 'height="24"');
  }

  /**
   * Resolve the API-signed expiry (Unix seconds) for an outbound service code
   * via the quote-ID matrix for the current pickup mode. The expiry is set
   * from the outbound despatch date, so it's identical across the return
   * column — column 0 is representative for both one-way and round trip.
   * Returns null when no quote/expiry can be resolved.
   */
  getOutboundExpiry(serviceCode) {
    const data = this.shippingData;
    if (!data) return null;
    const smcPrices = data.smcPrices || {};
    const pickupKey = this.getPickupModeKey();
    const outboundOrder =
      data.matrix?.outboundOrder || data.services?.outbound?.order || [];
    const outboundIndex = outboundOrder.indexOf(serviceCode);
    if (outboundIndex < 0) return null;
    const quoteId = data.matrix?.quoteIds?.[pickupKey]?.[outboundIndex]?.[0];
    const payload = quoteId ? smcPrices[quoteId] : null;
    return payload && Number.isFinite(payload.expiry) ? payload.expiry : null;
  }

  /**
   * A signed quote is expired once its `expiry` (Unix seconds) is at or behind
   * the current time — the same gate the cart-validation Function enforces at
   * checkout (it keeps entries where expiry > now). A missing/invalid expiry is
   * treated as expired so we never present an option that can't be signed.
   */
  isExpired(expiry) {
    if (!Number.isFinite(expiry)) return true;
    return expiry <= Math.floor(Date.now() / 1000);
  }

  setHandlingOptionDisabled(value, disabled) {
    const input = this.form?.querySelector(
      `input[name="dropoff_strategy"][value="${value}"]`,
    );
    if (!input) return;
    const option = input.closest(".handling-option");
    if (disabled) {
      input.setAttribute("disabled", "true");
      input.checked = false;
      option?.classList.add("disabled");
      option?.setAttribute("aria-disabled", "true");
    } else {
      input.removeAttribute("disabled");
      option?.classList.remove("disabled");
      option?.removeAttribute("aria-disabled");
    }
  }

  hasSelectedServices() {
    if (!this.selectedOutboundServiceCode) return false;
    if (this.querySelector("#round_trip")?.checked) {
      return !!this.selectedReturnServiceCode;
    }
    return true;
  }

  getSelectedService() {
    if (!this.hasSelectedServices()) return null;
    return {
      outboundCode: this.selectedOutboundServiceCode,
      returnCode: this.selectedReturnServiceCode,
    };
  }

  renderOutboundOptions(preserveSelection = false) {
    if (!this.serviceOptionsContainer) return;
    const services = this.shippingData?.services?.outbound;
    const order = services?.order || [];
    const prices = services?.prices || {};

    if (!order.length) {
      this.serviceOptionsContainer.innerHTML = `
        <div class="handling-option handling-option--placeholder">
          <div class="handling-option__content">
            <div class="handling-option__label-wrapper">
              <span class="handling-option__label">No services available</span>
            </div>
            <span class="handling-option__price">—</span>
          </div>
          <span class="handling-option__description">Adjust your dates or addresses to see available options.</span>
        </div>`;
      this.selectedOutboundServiceCode = null;
      return;
    }

    const pickupMode = this.getPickupModeKey();
    const available = order.map((code) => {
      const info = prices[code] || {};
      // Disable based on the API-signed expiry (Unix seconds) — the same gate
      // the cart-validation Function enforces at checkout. The API now returns
      // expired services too, so we show them greyed out rather than hide them.
      // Expiry is driven by the outbound despatch date and is identical across
      // the return column, so it's independent of the chosen return service.
      const disabled = this.isExpired(this.getOutboundExpiry(code));
      return { code, info, disabled };
    });
    const sortedAvailable = [...available].sort(
      (a, b) => Number(a.info.amount || 0) - Number(b.info.amount || 0),
    );

    // When every offerable service has expired there's nothing to pick up at
    // home either, so disable that handling option too.
    const homePickupAllDisabled = sortedAvailable.length
      ? sortedAvailable.every((item) => item.disabled)
      : false;
    this.setHandlingOptionDisabled("home_pickup", homePickupAllDisabled);

    if (
      pickupMode === "home_pickup" &&
      sortedAvailable.length &&
      sortedAvailable.every((item) => item.disabled)
    ) {
      const dropoffInput = this.form.querySelector(
        'input[name="dropoff_strategy"][value="deliver_to_fedex_warehouse"]',
      );
      if (dropoffInput && !dropoffInput.checked) {
        dropoffInput.checked = true;
        dropoffInput.dispatchEvent(new Event("change", { bubbles: true }));
        return;
      }
    }

    if (preserveSelection && this.selectedOutboundServiceCode) {
      const found = sortedAvailable.find(
        (item) => item.code === this.selectedOutboundServiceCode && !item.disabled,
      );
      if (!found) this.selectedOutboundServiceCode = null;
    }
    if (!this.selectedOutboundServiceCode) {
      const firstAvailable = sortedAvailable.find((item) => !item.disabled) || sortedAvailable[0];
      this.selectedOutboundServiceCode = firstAvailable?.code || null;
    }

    const pickupVerb = this.getPickupModeKey() === "home_pickup" ? "Picked up on" : "Drop off by";
    this.serviceOptionsContainer.innerHTML = "";
    sortedAvailable.forEach((item) => {
      const label = this.serviceLabelMap[item.code] || item.code;
      const price = this.formatMoneyFromNumber(Number(item.info.amount || 0));
      const description = item.info.shipDate
        ? `${pickupVerb} <strong>${this.formatDayOfWeek(item.info.shipDate)}</strong>`
        : pickupVerb;
      const isChecked = this.selectedOutboundServiceCode === item.code;
      const serviceIcon = this.getServiceIcon(item.code);
      const option = document.createElement("label");
      option.className = `handling-option${isChecked ? " active" : ""}${item.disabled ? " disabled" : ""}`;
      option.innerHTML = `
        <input type="radio" name="outbound_service_option" value="${item.code}" ${isChecked ? "checked" : ""} ${item.disabled ? "disabled" : ""}>
        <div class="handling-option__content">
          <div class="handling-option__label-wrapper">
            <span class="handling-option__label">${label}</span>
            ${serviceIcon}
          </div>
          <span class="handling-option__price">${price}</span>
        </div>
        <span class="handling-option__description">${description}</span>
      `;
      option.querySelector("input").addEventListener("change", () => {
        if (option.querySelector("input").checked) {
          this.selectedOutboundServiceCode = item.code;
          this.updatePricingAndSummary();
          this.renderOutboundOptions(true);
        }
      });
      this.serviceOptionsContainer.appendChild(option);
    });
  }

  renderReturnOptions(preserveSelection = false) {
    if (!this.returnOptionsContainer) return;
    const isRoundTrip = this.querySelector("#round_trip")?.checked;
    if (!isRoundTrip) {
      this.returnOptionsContainer.innerHTML = `
        <div class="handling-option handling-option--placeholder">
          <div class="handling-option__content">
            <div class="handling-option__label-wrapper">
              <span class="handling-option__label">Enable round trip to see return services</span>
            </div>
            <span class="handling-option__price">—</span>
          </div>
          <span class="handling-option__description">Return options appear after you confirm your bags.</span>
        </div>`;
      this.selectedReturnServiceCode = null;
      return;
    }

    const services = this.shippingData?.services?.return;
    const order = services?.order || [];
    const prices = services?.prices || {};

    if (!order.length) {
      this.returnOptionsContainer.innerHTML = `
        <div class="handling-option handling-option--placeholder">
          <div class="handling-option__content">
            <div class="handling-option__label-wrapper">
              <span class="handling-option__label">No return services available</span>
            </div>
            <span class="handling-option__price">—</span>
          </div>
          <span class="handling-option__description">Adjust your dates or addresses to see available options.</span>
        </div>`;
      this.selectedReturnServiceCode = null;
      return;
    }

    const returnPickupFee = isRoundTrip
      ? Number(this.shippingData?.fees?.return_home_pickup || 0)
      : 0;
    const available = order
      .map((code) => {
        const info = prices[code] || {};
        const totalAmount = Number(info.amount || 0) + returnPickupFee;
        return { code, info, totalAmount };
      })
      .sort((a, b) => a.totalAmount - b.totalAmount);

    if (preserveSelection && this.selectedReturnServiceCode) {
      const found = available.some((item) => item.code === this.selectedReturnServiceCode);
      if (!found) this.selectedReturnServiceCode = null;
    }
    if (!this.selectedReturnServiceCode) {
      this.selectedReturnServiceCode = available[0]?.code || null;
    }

    this.returnOptionsContainer.innerHTML = "";
    available.forEach((item) => {
      const label = this.serviceLabelMap[item.code] || item.code;
      const price = this.formatMoneyFromNumber(item.totalAmount);
      const description = item.info.deliveryDate
        ? `Delivery by <strong>${this.formatDayOfWeek(item.info.deliveryDate)}</strong>`
        : "Delivery by";
      const isChecked = this.selectedReturnServiceCode === item.code;
      const serviceIcon = this.getServiceIcon(item.code);
      const option = document.createElement("label");
      option.className = `handling-option${isChecked ? " active" : ""}`;
      option.innerHTML = `
        <input type="radio" name="return_service_option" value="${item.code}" ${isChecked ? "checked" : ""}>
        <div class="handling-option__content">
          <div class="handling-option__label-wrapper">
            <span class="handling-option__label">${label}</span>
            ${serviceIcon}
          </div>
          <span class="handling-option__price">${price}</span>
        </div>
        <span class="handling-option__description">${description}</span>
      `;
      option.querySelector("input").addEventListener("change", () => {
        if (option.querySelector("input").checked) {
          this.selectedReturnServiceCode = item.code;
          this.updatePricingAndSummary();
          this.renderReturnOptions(true);
        }
      });
      this.returnOptionsContainer.appendChild(option);
    });
  }

  updatePricingAndSummary() {
    const data = this.shippingData;
    if (!data || !this.shippingCostEl || !this.totalEl) {
      this.renderShippingSummaryPlaceholder();
      return;
    }

    const isRoundTrip = !!data.roundTrip && !!this.querySelector("#round_trip")?.checked;
    if (!this.selectedOutboundServiceCode || (isRoundTrip && !this.selectedReturnServiceCode)) {
      this.renderShippingSummaryPlaceholder();
      this.submitButton.setAttribute("data-disabled", true);
      return;
    }

    this.summaryCard?.classList.remove("loading");
    const outboundServices = data.services?.outbound || {};
    const returnServices = data.services?.return || {};
    const outboundPrices = outboundServices.prices || {};
    const returnPrices = returnServices.prices || {};

    const outboundInfo = this.selectedOutboundServiceCode
      ? outboundPrices[this.selectedOutboundServiceCode] || {}
      : {};
    const returnInfo = this.selectedReturnServiceCode
      ? returnPrices[this.selectedReturnServiceCode] || {}
      : {};

    const outboundAmount = Number(outboundInfo.amount || 0);
    const returnAmountBase = isRoundTrip ? Number(returnInfo.amount || 0) : 0;
    const insuranceTotal = Number(data.insuranceTotal || 0);

    const pickupMode = this.getPickupModeKey();
    const homePickupFeeRaw = Number(data.fees?.home_pickup || 0);
    const homePickupFee = pickupMode === "home_pickup" ? homePickupFeeRaw : 0;
    const returnPickupFee = isRoundTrip
      ? Number(data.fees?.return_home_pickup || 0)
      : 0;
    const returnAmount = isRoundTrip ? returnAmountBase + returnPickupFee : 0;

    this.shippingCostEl.dataset.shippingCost = outboundAmount;
    this.shippingCostEl.textContent = Shopify.formatMoney(outboundAmount * 100);

    if (this.returnCostEl) {
      this.returnCostEl.dataset.returnCost = returnAmount;
      if (isRoundTrip) {
        this.returnCostEl.closest(".pdp-rates__line")?.classList.remove("hidden");
        this.returnCostEl.textContent =
          returnAmount === 0 ? "Free" : Shopify.formatMoney(returnAmount * 100);
      } else {
        this.returnCostEl.closest(".pdp-rates__line")?.classList.add("hidden");
      }
    }

    if (this.rentalCostEl) {
      if (insuranceTotal === 0) {
        this.rentalCostEl.textContent = "Included";
        this.rentalCostEl.dataset.rentalCost = 0;
      } else {
        this.rentalCostEl.textContent = Shopify.formatMoney(insuranceTotal * 100);
        this.rentalCostEl.dataset.rentalCost = insuranceTotal;
      }
    }

    if (this.homeCollectionCostEl) {
      if (homePickupFee > 0) {
        this.homeCollectionCostEl.closest(".pdp-rates__line")?.classList.remove("hidden");
        this.homeCollectionCostEl.dataset.homeCollectionCost = homePickupFee;
        this.homeCollectionCostEl.textContent = Shopify.formatMoney(homePickupFee * 100);
      } else {
        this.homeCollectionCostEl.closest(".pdp-rates__line")?.classList.add("hidden");
        this.homeCollectionCostEl.dataset.homeCollectionCost = 0;
      }
    }

    this.updateHandlingPrices(homePickupFeeRaw);

    const total = outboundAmount + returnAmount + insuranceTotal + homePickupFee;
    this.totalEl.dataset.total = total;
    this.totalEl.textContent = Shopify.formatMoney(Math.round(total * 100));
    this.querySelector(".pdp-rates__summary").classList.remove("loading");
    this.submitButton.removeAttribute("data-disabled");
    this.updateAffirmWidget(total);

    this.updateQuoteIdFromMatrix();
    this.updateSummaryCard();
    this.setCardCollapsed(this.outboundCard, false);
    if (isRoundTrip) {
      this.setCardCollapsed(this.returnCard, false);
    }
  }

  /**
   * Build the array of signed price entries written to `_smc_price` on cart
   * add. Entry 0 is the customer's selected quote; subsequent entries are
   * fallbacks that ship LATER (so they remain feasible after entry 0's
   * pickup cutoff) for the same return service and pickup type, sorted by
   * price ascending so the cart transform picks the cheapest still-valid one.
   *
   * Returns [] when no signed payload exists for the selection (e.g. the
   * customer hasn't fully filled in the form yet) — caller skips writing
   * the property in that case.
   */
  buildSmcPriceEntries(selectedQuoteId) {
    const data = this.shippingData;
    if (!data || !selectedQuoteId) return [];

    const smcPrices = data.smcPrices || {};
    const selectedPayload = smcPrices[selectedQuoteId];
    if (!selectedPayload) return [];

    const matrix = data.matrix?.quoteIds;
    const outboundOrder = data.matrix?.outboundOrder || data.services?.outbound?.order || [];
    const returnOrder = data.matrix?.returnOrder || data.services?.return?.order || [];
    const outboundPrices = data.services?.outbound?.prices || {};
    const isRoundTrip = !!data.roundTrip && !!this.querySelector("#round_trip")?.checked;
    const pickupKey = this.getPickupModeKey();

    const entries = [selectedPayload];

    if (matrix && outboundOrder.length > 0) {
      const selectedOutbound = this.selectedOutboundServiceCode;
      const selectedReturn = this.selectedReturnServiceCode;
      const selectedOutboundIdx = outboundOrder.indexOf(selectedOutbound);
      const returnIdx = isRoundTrip
        ? Math.max(0, returnOrder.indexOf(selectedReturn))
        : 0;
      const selectedShipDate = outboundPrices[selectedOutbound]?.shipDate;

      const alternatives = [];
      outboundOrder.forEach((outService, idx) => {
        if (idx === selectedOutboundIdx) return;
        const altShipDate = outboundPrices[outService]?.shipDate;
        // Only include alternatives that ship LATER than the selection — these
        // are the higher-tier services that remain feasible after the
        // selection's despatch cutoff has passed.
        if (!altShipDate || !selectedShipDate || altShipDate <= selectedShipDate) return;
        const altQuoteId = matrix?.[pickupKey]?.[idx]?.[returnIdx];
        if (!altQuoteId) return;
        const altPayload = smcPrices[altQuoteId];
        if (!altPayload) return;
        alternatives.push(altPayload);
      });

      alternatives.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
      entries.push(...alternatives);
    }

    return entries;
  }

  updateQuoteIdFromMatrix() {
    const data = this.shippingData;
    if (!data) return;
    const isRoundTrip = !!data.roundTrip && !!this.querySelector("#round_trip")?.checked;
    const pickupKey = this.getPickupModeKey();
    let quoteId = "";

    if (data.matrix?.quoteIds) {
      const outboundOrder = data.matrix.outboundOrder || data.services?.outbound?.order || [];
      const outboundIndex = outboundOrder.indexOf(this.selectedOutboundServiceCode);

      if (isRoundTrip) {
        // Round trip: look up [outboundService][returnService] in the matrix
        const returnOrder = data.matrix.returnOrder || data.services?.return?.order || [];
        const returnIndex = returnOrder.indexOf(this.selectedReturnServiceCode);
        if (outboundIndex >= 0 && returnIndex >= 0) {
          quoteId =
            data.matrix.quoteIds?.[pickupKey]?.[outboundIndex]?.[returnIndex] || "";
        }
      } else {
        // One-way: matrix columns are all identical, so use column 0
        if (outboundIndex >= 0) {
          quoteId =
            data.matrix.quoteIds?.[pickupKey]?.[outboundIndex]?.[0] || "";
        }
      }
    }

    this.selectedServiceId = quoteId || null;
    if (this.shippingPriceInput) this.shippingPriceInput.value = quoteId;
    if (this.shippingServiceInput) {
      const parts = [this.selectedOutboundServiceCode, this.selectedReturnServiceCode].filter(Boolean);
      this.shippingServiceInput.value = parts.join("|");
    }

    const outboundInfo =
      data.services?.outbound?.prices?.[this.selectedOutboundServiceCode] || {};
    const returnInfo =
      data.services?.return?.prices?.[this.selectedReturnServiceCode] || {};
    if (this.shippingOutboundDateInput) {
      this.shippingOutboundDateInput.value = outboundInfo.shipDate || "";
    }
    if (this.shippingReturnDateInput) {
      this.shippingReturnDateInput.value = returnInfo.deliveryDate || "";
    }
  }

  updateTotals(service, handling) {
    // Reset totals if no service
    if (!service) {
      this.shippingCostEl.dataset.shippingCost = 0;
      this.shippingCostEl.textContent = Shopify.formatMoney(0);
      this.returnCostEl.dataset.returnCost = 0;
      this.returnCostEl.closest(".pdp-rates__line").classList.add("hidden");
      this.totalEl.dataset.total = 0;
      this.totalEl.textContent = Shopify.formatMoney(0);
      this.shippingPriceInput.value = "";
      this.shippingServiceInput.value = "";
      this.shippingOutboundDateInput.value = "";
      this.shippingReturnDateInput.value = "";
      this.submitButton.setAttribute("data-disabled", true);
      this.updateAffirmWidget(0);
      this.renderShippingSummaryPlaceholder();
      if (this.summaryCard) this.summaryCard.classList.remove("loading");
      return;
    }

    // Update hidden fields
    const quote = service.quoteID || {};
    this.shippingPriceInput.value = quote.id || "";
    this.shippingServiceInput.value = service.serviceType || "";
    this.shippingOutboundDateInput.value = quote.outbound_despatch_date || service.shippingDate || "";
    this.shippingReturnDateInput.value = quote.return_despatch_date || quote.return_delivery_estimate_date || service.return_delivery_estimate_date || "";

    // Update return cost (if provided)
    if (service.returnCost !== null && service.returnCost !== undefined) {
      this.returnCostEl.dataset.returnCost = parseFloat(service.returnCost);
      this.returnCostEl.closest(".pdp-rates__line").classList.remove("hidden");
      this.returnCostEl.textContent =
        service.returnCost == 0
          ? "Free"
          : Shopify.formatMoney(service.returnCost * 100);
    } else {
      this.returnCostEl.closest(".pdp-rates__line").classList.add("hidden");
      this.returnCostEl.dataset.returnCost = 0;
    }

    // Shipping cost uses amount
    const shippingAmount = Number(service.amount || 0);
    this.shippingCostEl.dataset.shippingCost = shippingAmount;
    this.shippingCostEl.textContent = Shopify.formatMoney(shippingAmount * 100);

    // Rental/insurance cost still same logic (already set elsewhere before?)
    if (service.totalInsuranceCost == null) {
      // keep existing rental cost values
    } else {
      if (Number(service.totalInsuranceCost) === 0) {
        this.rentalCostEl.textContent = "Included";
        this.rentalCostEl.dataset.rentalCost = 0;
      } else {
        this.rentalCostEl.textContent = Shopify.formatMoney(
          Number(service.totalInsuranceCost) * 100,
        );
        this.rentalCostEl.dataset.rentalCost = Number(service.totalInsuranceCost);
      }
    }

    // Home pickup fee comes from service.home_pickup_fee
    const homePickupFee = service.home_pickup_fee || 0;
    if (homePickupFee) {
      this.homeCollectionCostEl
        .closest(".pdp-rates__line")
        .classList.remove("hidden");
      this.homeCollectionCostEl.dataset.homeCollectionCost = homePickupFee;
      this.homeCollectionCostEl.textContent = Shopify.formatMoney(
        homePickupFee * 100,
      );
    } else {
      this.homeCollectionCostEl
        .closest(".pdp-rates__line")
        .classList.add("hidden");
      this.homeCollectionCostEl.dataset.homeCollectionCost = 0;
    }
    this.updateHandlingPrices(homePickupFee);

    const finalShippingCost = Number(this.shippingCostEl.dataset.shippingCost);
    const finalRentalCost = Number(this.rentalCostEl.dataset.rentalCost || 0);
    const finalReturnCost = Number(this.returnCostEl.dataset.returnCost || 0);
    const finalHomeCollectionCost = Number(
      this.homeCollectionCostEl.dataset.homeCollectionCost || 0,
    );

    this.totalEl.dataset.total =
      finalShippingCost +
      finalRentalCost +
      finalReturnCost +
      finalHomeCollectionCost;

    this.totalEl.textContent = Shopify.formatMoney(
      Math.round(this.totalEl.dataset.total * 100),
    );
    this.querySelector(".pdp-rates__summary").classList.remove("loading");
    this.submitButton.removeAttribute("data-disabled");
    this.updateAffirmWidget(this.totalEl.dataset.total);
    this.updateSummaryCard(service);
  }

  getSelectedService() {
    if (!this.hasSelectedServices()) return null;
    return {
      outboundCode: this.selectedOutboundServiceCode,
      returnCode: this.selectedReturnServiceCode,
    };
  }

  formatAddressParts(addressObj, fallback) {
    if (!addressObj) return fallback || "";
    const parts = [
      addressObj.address,
      addressObj.stateCode,
    ]
      .filter(Boolean)
      .join(", ");
    return parts || fallback || "";
  }

  /**
   * Mark a field's text as the display form of the structured address in
   * sessionStorage (suggestion click, course pick, modal save, auto-resolve).
   * Bumps the resolution generation so any automatic resolution still in
   * flight for older text discards its result.
   */
  markAddressResolved(field) {
    if (!field) return;
    field.dataset.addressSelected = "true";
    field._resolveGen = (field._resolveGen || 0) + 1;
    this.clearAddressFieldError(field);
  }

  /**
   * True when the visible text was never resolved into the structured address
   * the quote and labels use — typed, pasted or autofilled text that no
   * suggestion click, course pick or modal save produced.
   */
  isAddressFieldUnresolved(field) {
    if (!field || field.disabled) return false;
    const value = field.value.trim();
    if (!value) return false;
    if (field.dataset.addressSelected === "true") return false;
    const prefix = field.name === "origin" ? "refulfil:origin" : "refulfil:destination";
    return value !== this.getStoredAddressDisplay(prefix);
  }

  clearStoredAddress(prefix) {
    ["company", "course", "address", "address2", "city", "state", "postal"].forEach((key) =>
      sessionStorage.removeItem(`${prefix}:${key}`),
    );
  }

  /**
   * Only text that pins down one place is resolved automatically: a leading
   * street number plus either a postcode or a further comma-separated part
   * (city). A bare street line could match the same street in another city.
   */
  looksLikeFullAddress(text) {
    const value = String(text || "").trim();
    if (!/^\d+[a-z]?\s+\S/i.test(value)) return false;
    const rest = value.replace(/^\d+[a-z]?\s*/i, "");
    const hasPostcode = /\b\d{5}\b/.test(rest);
    const parts = value.split(",").map((p) => p.trim()).filter(Boolean);
    return hasPostcode || parts.length >= 2;
  }

  /** The typed text must agree with the resolved place on street number and any typed postcode. */
  typedTextAgreesWith(text, parsed) {
    const typedNumber = (String(text).trim().match(/^(\d+[a-z]?)\b/i) || [])[1];
    const resolvedNumber = (String(parsed.address || "").match(/^(\d+[a-z]?)\b/i) || [])[1];
    if (typedNumber && (!resolvedNumber || typedNumber.toLowerCase() !== resolvedNumber.toLowerCase())) {
      return false;
    }
    const rest = String(text).replace(/^\s*\d+[a-z]?\s*/i, "");
    const typedPostcodes = rest.match(/\b\d{5}\b/g) || [];
    if (typedPostcodes.length > 0 && !typedPostcodes.includes(parsed.postalCode)) {
      return false;
    }
    return true;
  }

  /**
   * Turn text the customer typed, pasted or autofilled into the address box
   * (without clicking a suggestion) into a resolved structured address.
   *
   * Browser autofill, paste and Tab/Enter all leave the visible field holding
   * text the structured sessionStorage address knows nothing about; order
   * #5521 quoted and printed labels from the previous pickup address that
   * way. Resolves through the same Places lookup a suggestion click uses and
   * accepts the top result only when it is unambiguous (looksLikeFullAddress +
   * typedTextAgreesWith). Otherwise it prompts to pick from the suggestions and
   * drops the stale structured address so nothing can be quoted or booked
   * against it.
   *
   * @returns {Promise<boolean>} true when the field now holds a resolved address
   */
  resolveTypedAddress(field) {
    if (!field || field.disabled) return Promise.resolve(true);
    if (field._resolution) return field._resolution;

    const run = async () => {
      const text = field.value.trim();
      if (!text) return false;
      if (!this.isAddressFieldUnresolved(field)) return true;

      const prefix = field.name === "origin" ? "refulfil:origin" : "refulfil:destination";
      const gen = field._resolveGen || 0;
      const stillCurrent = () => (field._resolveGen || 0) === gen && field.value.trim() === text;

      let resolved = null;
      if (
        this.looksLikeFullAddress(text) &&
        window.google?.maps?.places &&
        this.autocompleteService &&
        this.placesService
      ) {
        try {
          const predictions = await new Promise((resolve) => {
            this.autocompleteService.getPlacePredictions(
              { input: text, componentRestrictions: { country: "us" } },
              (preds, status) =>
                resolve(status === google.maps.places.PlacesServiceStatus.OK && preds ? preds : []),
            );
          });
          const top = predictions[0];
          const place = top ? await this.fetchPlaceDetails(top.place_id) : null;
          const parsed = place ? this.parsePlaceComponents(place) : null;
          if (parsed && this.isStoredAddressComplete(parsed) && this.typedTextAgreesWith(text, parsed)) {
            resolved = { place, parsed };
          }
        } catch (e) {
          console.warn("Address resolution failed:", e);
        }
      }

      // The customer picked a suggestion or kept editing while we looked up
      // the old text: whatever they did wins.
      if (!stillCurrent()) return !this.isAddressFieldUnresolved(field);

      if (resolved) {
        this.applyResolvedAddress(field, resolved.place, resolved.parsed);
        return true;
      }

      // Unresolvable: the previous structured address must not survive as the
      // silent fallback. Drop it, show what that means in the summary, and ask
      // for a pick from the suggestions.
      this.clearStoredAddress(prefix);
      if (field.name === "destination") this.postalCode = null;
      this.updateSummaryMapFromStorage();
      this.updateSummaryCard();
      this.updateAddressCallout();
      this.showAddressFieldError(
        field,
        `We couldn't confirm this ${field.name === "origin" ? "pickup" : "delivery"} address. Please pick it from the suggestions.`,
      );
      return false;
    };

    field._resolution = run().finally(() => {
      field._resolution = null;
    });
    return field._resolution;
  }

  /**
   * Resolve any address box still holding unresolved text before add-to-cart.
   * Returns the field that could not be resolved (caller focuses it), or null.
   */
  async ensureAddressesResolved() {
    for (const field of [this.originField, this.destinationField]) {
      if (!field || field.disabled) continue;
      if (field._resolution) await field._resolution;
      if (this.isAddressFieldUnresolved(field)) {
        const ok = await this.resolveTypedAddress(field);
        if (!ok) return field;
      }
    }
    return null;
  }

  /** Bag rows from the form values, as sent to /smc-shipping. */
  collectBagItems(values) {
    const bag_items = [];
    let index = 1;
    while (true) {
      const insurance = values[`insurance_value${index > 1 ? `_${index}` : ""}`];
      const insuranceValue = insurance ? Number(insurance) : 0;
      const bagType = values[`bag_type${index > 1 ? `_${index}` : ""}`];
      if (!bagType && !insurance) break;
      bag_items.push({ insurance_value: insuranceValue, bag_type: bagType });
      index++;
    }
    return bag_items;
  }

  /**
   * Everything the quote depends on, from the current form state. Stored on
   * a successful fetch and compared at add-to-cart so a line can never carry
   * quote ids fetched for different addresses, dates or bags.
   */
  quoteFingerprint() {
    if (!this.form) return "";
    const values = Object.fromEntries(new FormData(this.form).entries());
    const isRoundTrip = !!this.querySelector("#round_trip")?.checked;
    return JSON.stringify({
      bags: this.collectBagItems(values),
      origin: this.getStoredOrigin(),
      destination: this.getStoredDestination(),
      first_date: values["first_date"] || "",
      last_date: isRoundTrip ? values["last_date"] || "" : "",
      round_trip: isRoundTrip,
      variant: document.querySelector(".product-variant-id")?.value || "",
    });
  }

  isQuoteStale() {
    return !this.shippingData || this.shippingDataFingerprint !== this.quoteFingerprint();
  }

  showQuoteRefreshError() {
    const summary = this.querySelector(".pdp-rates__summary");
    if (!summary) return;
    let errorEl = summary.querySelector("[data-quote-error]");
    if (!errorEl) {
      errorEl = document.createElement("p");
      errorEl.setAttribute("data-quote-error", "");
      errorEl.style.color = "#c0392b";
      errorEl.style.fontSize = "0.85em";
      errorEl.style.marginTop = "0.5rem";
      summary.appendChild(errorEl);
    }
    errorEl.textContent =
      "We couldn't refresh shipping prices for your trip details. Please check your addresses and dates, then try again.";
  }

  clearQuoteRefreshError() {
    this.querySelector(".pdp-rates__summary")?.querySelector("[data-quote-error]")?.remove();
  }

  getStoredAddressDisplay(prefix) {
    const company = sessionStorage.getItem(`${prefix}:company`) || "";
    const address = sessionStorage.getItem(`${prefix}:address`) || "";
    const address2 = sessionStorage.getItem(`${prefix}:address2`) || "";
    const city = sessionStorage.getItem(`${prefix}:city`) || "";
    const state = sessionStorage.getItem(`${prefix}:state`) || "";
    const postal = sessionStorage.getItem(`${prefix}:postal`) || "";
    const cityState = [city, state].filter(Boolean).join(", ");
    return [company, address, address2, cityState, postal].filter(Boolean).join(", ");
  }

  getStoredAddress(prefix) {
    return {
      company: sessionStorage.getItem(`${prefix}:company`) || "",
      address: sessionStorage.getItem(`${prefix}:address`) || "",
      address2: sessionStorage.getItem(`${prefix}:address2`) || "",
      city: sessionStorage.getItem(`${prefix}:city`) || "",
      stateCode: sessionStorage.getItem(`${prefix}:state`) || "",
      postalCode: sessionStorage.getItem(`${prefix}:postal`) || "",
    };
  }

  getStoredOrigin() {
    return this.getStoredAddress("refulfil:origin");
  }

  getStoredDestination() {
    return this.getStoredAddress("refulfil:destination");
  }

  /**
   * A structured address is only usable by the backend (and FedEx) when it
   * carries a street line, city and postal code. The visible text field can
   * hold a value while these sessionStorage keys are empty — e.g. when the
   * field was prefilled from the legacy `refulfil:originAddress` string, or
   * when a Google place was selected without address_components. In those
   * cases we must block the quote rather than send a blank originAddress.
   */
  isStoredAddressComplete(addr) {
    return Boolean(addr && addr.address && addr.city && addr.postalCode);
  }

  /**
   * Validate that both origin and destination have complete structured data
   * before we POST to /smc-shipping or add to cart. Returns the offending
   * field element (and surfaces an inline error) when invalid, else null.
   */
  validateStructuredAddresses() {
    const checks = [
      { field: this.originField, addr: this.getStoredOrigin(), label: "pickup" },
      { field: this.destinationField, addr: this.getStoredDestination(), label: "delivery" },
    ];

    let firstInvalid = null;
    for (const { field, addr, label } of checks) {
      if (!field) continue;
      if (this.isStoredAddressComplete(addr)) {
        this.clearAddressFieldError(field);
        continue;
      }
      this.showAddressFieldError(
        field,
        `Please select a ${label} address from the suggestions so we can quote shipping.`,
      );
      if (!firstInvalid) firstInvalid = field;
    }
    return firstInvalid;
  }

  showAddressFieldError(field, message) {
    const group = field.closest(".form-group");
    if (!group) return;
    field.setAttribute("aria-invalid", "true");
    // Clear the stale display so a half-filled value can't masquerade as valid.
    field.dataset.addressSelected = "false";
    let errorEl = group.querySelector("[data-address-error]");
    if (!errorEl) {
      errorEl = document.createElement("p");
      errorEl.setAttribute("data-address-error", "");
      errorEl.style.color = "#c0392b";
      errorEl.style.fontSize = "0.85em";
      errorEl.style.marginTop = "0.25rem";
      group.appendChild(errorEl);
    }
    errorEl.textContent = message;
  }

  clearAddressFieldError(field) {
    const group = field.closest(".form-group");
    if (!group) return;
    field.removeAttribute("aria-invalid");
    const errorEl = group.querySelector("[data-address-error]");
    if (errorEl) errorEl.remove();
  }

  getFormDates() {
    return {
      deliveryByOutbound: this.form?.querySelector("#first_date")?.value || "",
      returnCollectionDate: this.form?.querySelector("#last_date")?.value || "",
    };
  }

  setupAddressFieldResets() {
    const fields = [this.originField, this.destinationField].filter(Boolean);
    fields.forEach((field) => {
      // A mousedown on our own suggestions list blurs the input before the
      // row's click handler runs. Remember it so the blur handler below leaves
      // the pick to the click instead of racing it with an automatic
      // resolution of the typed text.
      const container = field.closest(".form-group")?.querySelector(".autocomplete-container");
      container?.addEventListener("mousedown", () => {
        field._pickingSuggestion = true;
        setTimeout(() => {
          field._pickingSuggestion = false;
        }, 600);
      });

      field.addEventListener("focus", () => {
        if (field.dataset.skipClearOnFocus === "true") {
          delete field.dataset.skipClearOnFocus;
          return;
        }
        field.dataset.addressSelected = "false";
        field.value = "";
      });

      // Enter inside an address box must not submit the form; treat it as
      // leaving the field so the typed text gets resolved like Tab does.
      field.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          field.blur();
        }
      });

      field.addEventListener("blur", () => {
        if (field.dataset.addressSelected === "true") return;
        const prefix = field.name === "origin" ? "refulfil:origin" : "refulfil:destination";

        if (field.value.trim() === "") {
          // Clicked in and out without typing: the stored address still stands.
          const storedValue = this.getStoredAddressDisplay(prefix);
          if (storedValue) {
            field.value = storedValue;
            field.dataset.addressSelected = "true";
            this.updateSummaryMapFromStorage();
            this.updateSummaryCard();
          }
          return;
        }

        if (field._pickingSuggestion) return;

        if (!this.isAddressFieldUnresolved(field)) {
          field.dataset.addressSelected = "true";
          return;
        }

        // Text the customer typed, pasted or autofilled without picking a
        // suggestion: resolve it now rather than quoting/booking against the
        // previous structured address (the order #5521 failure mode).
        this.resolveTypedAddress(field);
      });
    });
  }

  renderShippingSummaryPlaceholder() {
    if (!this.shippingSummaryContainer) return;

    const pricingSummary = this.querySelector(".pdp-rates__pricing-summary");
    if (pricingSummary) {
      pricingSummary.classList.add("is-placeholder");
      pricingSummary.closest(".smc-summary-card")?.classList.add("is-placeholder");
    }

    const pickupVerb =
      this.getPickupModeKey() === "home_pickup" ? "Picked up on" : "Drop off by";
    const isRoundTrip = this.querySelector("#round_trip")?.checked;
    const { deliveryByOutbound, returnCollectionDate } = this.getFormDates();
    const origin = this.getStoredOrigin();
    const destination = this.getStoredDestination();
    const outboundPickupLabel = "Select a service";
    const outboundDeliveryLabel = deliveryByOutbound
      ? this.formatFriendlyDate(deliveryByOutbound)
      : "Select a date";
    const returnCollectionLabel = returnCollectionDate
      ? this.formatFriendlyDate(returnCollectionDate)
      : "Select a date";
    const returnDeliveryLabel = "Select a service";
    const outboundRow = `
      <div class="shipping-summary__row">
        <div class="shipping-summary__address">
          <div class="shipping-summary__label">${pickupVerb} <span class="shipping-summary__date">${outboundPickupLabel}</span></div>
          <div class="shipping-summary__address-line">${this.formatAddressParts(origin, "Add pickup address")}</div>
        </div>
        <div class="shipping-summary__icon" aria-hidden="true">${this.iconGround}</div>
        <div class="shipping-summary__address">
          <div class="shipping-summary__label">Delivery by <span class="shipping-summary__date">${outboundDeliveryLabel}</span></div>
          <div class="shipping-summary__address-line">${this.formatAddressParts(destination, "Add delivery address")}</div>
        </div>
      </div>
    `;

    const returnRow = `
      <div class="shipping-summary__row">
        <div class="shipping-summary__address">
          <div class="shipping-summary__label">Picked up on <span class="shipping-summary__date">${returnCollectionLabel}</span></div>
          <div class="shipping-summary__address-line">${this.formatAddressParts(destination, "Return collection address")}</div>
        </div>
        <div class="shipping-summary__icon" aria-hidden="true">${this.iconReturn}</div>
        <div class="shipping-summary__address">
          <div class="shipping-summary__label">Delivery by <span class="shipping-summary__date">${returnDeliveryLabel}</span></div>
          <div class="shipping-summary__address-line">${this.formatAddressParts(origin, "Return delivery address")}</div>
        </div>
      </div>
    `;

    this.shippingSummaryContainer.innerHTML = `
      <div class="shipping-summary__placeholder" aria-live="polite">
        ${outboundRow}
        ${isRoundTrip ? returnRow : ""}
      </div>
    `;

    if (this.summaryCard) this.summaryCard.classList.remove("loading");
  }

  updateSummaryCard() {
    if (!this.shippingSummaryContainer) return;

    const pricingSummary = this.querySelector(".pdp-rates__pricing-summary");
    if (pricingSummary) {
      if (!this.hasSelectedServices() || !this.shippingData) {
        pricingSummary.classList.add("is-placeholder");
        pricingSummary.closest(".smc-summary-card")?.classList.add("is-placeholder");
      } else {
        pricingSummary.classList.remove("is-placeholder");
        pricingSummary.closest(".smc-summary-card")?.classList.remove("is-placeholder");
      }
    }

    const pickupVerb = this.getPickupModeKey() === "home_pickup" ? "Picked up on" : "Drop off by";
    const origin = this.getStoredOrigin();
    const destination = this.getStoredDestination();

    const outboundInfo =
      this.shippingData?.services?.outbound?.prices?.[this.selectedOutboundServiceCode] || {};
    const returnInfo =
      this.shippingData?.services?.return?.prices?.[this.selectedReturnServiceCode] || {};
    const { deliveryByOutbound, returnCollectionDate } = this.getFormDates();
    const isRoundTrip = this.querySelector("#round_trip")?.checked;

    const outboundIcon = this.selectedOutboundServiceCode
      ? this.getOutboundIcon(this.selectedOutboundServiceCode)
      : this.iconGround;
    const outboundPickupLabel = outboundInfo.shipDate
      ? this.formatFriendlyDate(outboundInfo.shipDate)
      : "Select a service";
    const outboundDeliveryLabel = deliveryByOutbound
      ? this.formatFriendlyDate(deliveryByOutbound)
      : "Select a date";
    const returnCollectionLabel = returnCollectionDate
      ? this.formatFriendlyDate(returnCollectionDate)
      : "Select a date";
    const returnDeliveryLabel = returnInfo.deliveryDate
      ? this.formatFriendlyDate(returnInfo.deliveryDate)
      : "Select a service";
    const outboundRow = `
      <div class="shipping-summary__row">
        <div class="shipping-summary__address">
          <div class="shipping-summary__label">${pickupVerb} <span class="shipping-summary__date">${outboundPickupLabel}</span></div>
          <div class="shipping-summary__address-line">${this.formatAddressParts(origin, "Add pickup address")}</div>
        </div>
        <div class="shipping-summary__icon">${outboundIcon}</div>
        <div class="shipping-summary__address">
          <div class="shipping-summary__label">Delivery by <span class="shipping-summary__date">${outboundDeliveryLabel}</span></div>
          <div class="shipping-summary__address-line">${this.formatAddressParts(destination, "Add delivery address")}</div>
        </div>
      </div>
    `;

    let returnRow = "";
    if (isRoundTrip) {
      returnRow = `
        <div class="shipping-summary__row">
          <div class="shipping-summary__address">
            <div class="shipping-summary__label">Picked up on <span class="shipping-summary__date">${returnCollectionLabel}</span></div>
            <div class="shipping-summary__address-line">${this.formatAddressParts(destination, "Return collection address")}</div>
          </div>
          <div class="shipping-summary__icon">${this.iconReturn}</div>
          <div class="shipping-summary__address">
            <div class="shipping-summary__label">Delivery by <span class="shipping-summary__date">${returnDeliveryLabel}</span></div>
            <div class="shipping-summary__address-line">${this.formatAddressParts(origin, "Return delivery address")}</div>
          </div>
        </div>
      `;
    }

    this.shippingSummaryContainer.innerHTML = outboundRow + returnRow;
    if (this.summaryCard) this.summaryCard.classList.remove("loading");
  }

  updateAffirmWidget(totalPrice) {
    const affirmWidget = this.querySelector('.affirm-widget');
    if (!affirmWidget) return;

    const priceText = affirmWidget.querySelector('.affirm-widget__price-text');
    const monthlyPriceElement = affirmWidget.querySelector('.affirm-widget__monthly-price');

    if (!priceText || !monthlyPriceElement) return;

    // Validate price
    const numericPrice = parseFloat(totalPrice);
    
    if (!isNaN(numericPrice) && numericPrice > 0) {
      // Divide by 12 months (no interest calculation for custom form)
      const monthlyPrice = numericPrice / 12;
      
      // Format and display
      monthlyPriceElement.textContent = Shopify.formatMoney(monthlyPrice * 100);
      priceText.style.display = 'inline';
    } else {
      // Hide the monthly price if invalid
      priceText.style.display = 'none';
    }
  }

  updateAddressCallout() {
    // Fresh-query the callout element (it lives inside the trip card)
    const callout = this.querySelector("[data-address-callout]") || document.querySelector("[data-address-callout]");
    if (!callout) return;

    // Check if either origin or destination is missing a company field
    const originCompany = sessionStorage.getItem("refulfil:origin:company") || "";
    const destCompany = sessionStorage.getItem("refulfil:destination:company") || "";
    const originHasAddress = sessionStorage.getItem("refulfil:origin:address") || "";
    const destHasAddress = sessionStorage.getItem("refulfil:destination:address") || "";

    // Only show the callout if at least one address has been entered but is missing company
    const shouldShow = (originHasAddress && !originCompany) || (destHasAddress && !destCompany);

    if (shouldShow) {
      // Use rAF to ensure the browser has painted the hidden state first,
      // so the CSS transition actually fires
      requestAnimationFrame(() => {
        callout.classList.add("visible");
      });
    } else {
      callout.classList.remove("visible");
    }
  }

  debounce(fn, delay) {
    let timer;
    const debounced = (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
    debounced.cancel = () => {
      clearTimeout(timer);
    };
    return debounced;
  }
}

if (!customElements.get("custom-product-form")) {
  customElements.define("custom-product-form", CustomProductForm);
}

window.initMap = function initMap() {
  const form = document.querySelector("custom-product-form");
  if (form && typeof form.initSummaryMapWhenReady === "function") {
    form.initSummaryMapWhenReady();
  }
};
